import type {
  AuthorizationCondition,
  AuthorizationDecision,
  AuthorizationEffect,
  AuthorizationMatchedBy,
  AuthorizationPolicyCondition,
  AuthorizationPolicyRule,
  AuthorizationPolicySnapshot,
  AuthorizationPrincipalType,
  AuthorizationRequest,
  WorkforcePrincipalAffiliation,
  WorkforcePrincipalContext,
  WorkforceRole,
} from "@billiard/contracts";
import { isAuthorizationPolicySnapshot } from "@billiard/contracts";

export const AUTHORIZATION_POLICY_V1_VERSION = 1;
export const AUTHORIZATION_POLICY_V1_CONTENT_SHA256 =
  "16aca33f521ce81ec4ea15207e0728e71a7dd35f338314cab022c8329cd24e6b";
export const AUTHORIZATION_POLICY_V2_VERSION = 2;
export const AUTHORIZATION_POLICY_V2_CONTENT_SHA256 =
  "802882a374c0fe7b3ac075c0c8ca363af160575c1e1f76532457e4ea318b9665";
export const AUTHORIZATION_POLICY_V3_VERSION = 3;
export const AUTHORIZATION_POLICY_V3_CONTENT_SHA256 =
  "69dc544ffa4d7f22a43145aad36a0a3f886e279f68f6725a5c29b8b30473d399";
export const AUTHORIZATION_POLICY_V4_VERSION = 4;
export const AUTHORIZATION_POLICY_V4_CONTENT_SHA256 =
  "b0acb8a02b397fdad93318bbbda47bd071722deeb3aaca2b3cf3cea05daabe97";
export const AUTHORIZATION_POLICY_V5_VERSION = 5;
export const AUTHORIZATION_POLICY_V5_CONTENT_SHA256 =
  "35548cf2133b46d6b13e1227c719d2c26fac9bf5f80721b99d044ff428a905cb";
export const AUTHORIZATION_POLICY_V6_VERSION = 6;
export const AUTHORIZATION_POLICY_V6_CONTENT_SHA256 =
  "99860c8bc93a227dd10861d4eed1e742bbf613f0b8fbd9ee85da5d901f42ee11";
export const AUTHORIZATION_POLICY_V7_VERSION = 7;
export const AUTHORIZATION_POLICY_V7_CONTENT_SHA256 =
  "4d94df08539a64768f1747dc510e65022be3840cebeea320c2f8c4eec5e13fa1";
export const AUTHORIZATION_POLICY_V8_VERSION = 8;
export const AUTHORIZATION_POLICY_V8_CONTENT_SHA256 =
  "7363e5fb91d6ca97365ffe7456191cd1a5df73017fbdd3aed6e0adbd773bbe22";
export const AUTHORIZATION_POLICY_V9_VERSION = 9;
export const AUTHORIZATION_POLICY_V9_CONTENT_SHA256 =
  "4e4b310239c7e16b84b03f2a06cf85e911362706c237ecd973e8623ddff5f47d";
export const AUTHORIZATION_POLICY_V10_VERSION = 10;
export const AUTHORIZATION_POLICY_V10_CONTENT_SHA256 =
  "cf7417f0ef954c15c79e67aae2290295fb692ac4f4ff4939d18a4506ebf08cb4";
export const AUTHORIZATION_POLICY_V11_VERSION = 11;
export const AUTHORIZATION_POLICY_V11_CONTENT_SHA256 =
  "966617412fdad193d3c267c94e0e574f7810a183178179670fe0e813e617ef00";
export const AUTHORIZATION_POLICY_V12_VERSION = 12;
export const AUTHORIZATION_POLICY_V12_CONTENT_SHA256 =
  "a02a1c223e02758c6f9512c1bf52d9eb1c2590e25c8fa18bb8791b06294caff5";
export const AUTHORIZATION_POLICY_V13_VERSION = 13;
export const AUTHORIZATION_POLICY_V13_CONTENT_SHA256 =
  "5105abe433e4c6e455868835760008a7ff5a99ca3985606b69163db67d0ae6fc";
export const AUTHORIZATION_POLICY_V14_VERSION = 14;
export const AUTHORIZATION_POLICY_V14_CONTENT_SHA256 =
  "96ffd02654492c27fc834c4e5ddf746819c1cbabfe9e9422a4b91e980871ac6b";
export const AUTHORIZATION_POLICY_V15_VERSION = 15;
export const AUTHORIZATION_POLICY_V15_CONTENT_SHA256 =
  "c63e68bb51eda3e63f07eeabe7bd0c072ae5b6ebacf5dc3c518d7534033a0609";
export const AUTHORIZATION_POLICY_V16_VERSION = 16;
export const AUTHORIZATION_POLICY_V16_CONTENT_SHA256 =
  "2609cf303531aca4c109fbb777f2972f8b88c09503501d1002671a9c3a8c4d2b";
export const AUTHORIZATION_POLICY_V17_VERSION = 17;
export const AUTHORIZATION_POLICY_V17_CONTENT_SHA256 =
  "dd1a7df0073f627584eae471cfc2f090cf52c466ae3b6ac02ed2b94c2ee6708a";
export const AUTHORIZATION_POLICY_V18_VERSION = 18;
export const AUTHORIZATION_POLICY_V18_CONTENT_SHA256 =
  "795afe926f14b3da82f03974c9a61d12989fcb9060bcb77107e0435fbfc354d7";
export const AUTHORIZATION_POLICY_V19_VERSION = 19;
export const AUTHORIZATION_POLICY_V19_CONTENT_SHA256 =
  "b40ba480b8b2e25f69d4b15117db15cdb87ad4d3104cf4c69566eacd1211532a";
export const AUTHORIZATION_POLICY_V20_VERSION = 20;
export const AUTHORIZATION_POLICY_V20_CONTENT_SHA256 =
  "d916ce70db125e6d4b8e127a104eee3bc73268202c1f2549d6da042382f24b85";
export const AUTHORIZATION_POLICY_V21_VERSION = 21;
export const AUTHORIZATION_POLICY_V21_CONTENT_SHA256 =
  "903512ff23ac8251053f0e7610283c96460df5dbbc0a961e720bf44d2bdf3fc6";
export const AUTHORIZATION_POLICY_V22_VERSION = 22;
export const AUTHORIZATION_POLICY_V22_CONTENT_SHA256 =
  "b4ff3829d3108e50986f1d80a3e636a581329a4d3f5f6b9346208f0057bf18f8";
export const AUTHORIZATION_POLICY_V23_VERSION = 23;
export const AUTHORIZATION_POLICY_V23_CONTENT_SHA256 =
  "027ce76ec104074ce754c2609a05de591ed3c8d79f9c135b58a48cf7aaa37929";
export const AUTHORIZATION_POLICY_V24_VERSION = 24;
export const AUTHORIZATION_POLICY_V24_CONTENT_SHA256 =
  "17d10fe1f78b858b29ba3b985bb087cf845303e3bd43e7b7541c68ae11458ccd";
export const AUTHORIZATION_POLICY_V25_VERSION = 25;
export const AUTHORIZATION_POLICY_V25_CONTENT_SHA256 =
  "3c86dbab002df173557e7d3296cfcb959feea8710998d223f1be382ac88eab3a";
export const AUTHORIZATION_POLICY_V26_VERSION = 26;
export const AUTHORIZATION_POLICY_V26_CONTENT_SHA256 =
  "a862e18353b6c220a431eb40ef9c976f91bce76115f231b19555877eed0f521b";
export const AUTHORIZATION_POLICY_V27_VERSION = 27;
export const AUTHORIZATION_POLICY_V27_CONTENT_SHA256 =
  "39d605da08c0ca2df5b98404a187e6e719d0ae90aaeaeeb05e75a13dd1afd6f8";
export const AUTHORIZATION_POLICY_V28_VERSION = 28;
export const AUTHORIZATION_POLICY_V28_CONTENT_SHA256 =
  "e12a6c8b01bc327a87c0d93ef3fd377376ad964b7caa5df1856806fe27723c73";
export const AUTHORIZATION_POLICY_V29_VERSION = 29;
export const AUTHORIZATION_POLICY_V29_CONTENT_SHA256 =
  "d04c5d64c14acc50e8accbd8cf0b7c0135d18a5df76ff204328e4c3ae4b0e781";
export const AUTHORIZATION_POLICY_V30_VERSION = 30;
export const AUTHORIZATION_POLICY_V30_CONTENT_SHA256 =
  "7c142cd443c08e78faf6c65608f0cb57b9339161c5c0acbd9bbe8fa64f8d492f";
export const AUTHORIZATION_POLICY_V31_VERSION = 31;
export const AUTHORIZATION_POLICY_V31_CONTENT_SHA256 =
  "3a11b96e6da0734257b7ee3476f76554faf982fef7cb0194b98b49ba3a81a49b";
export const AUTHORIZATION_POLICY_V32_VERSION = 32;
export const AUTHORIZATION_POLICY_V32_CONTENT_SHA256 =
  "f043fa10db6bf8862c5c0fbf1fa2d4eb8f5d49624fcf5195e1a9e6fc28668c26";
export const AUTHORIZATION_POLICY_V33_VERSION = 33;
export const AUTHORIZATION_POLICY_V33_CONTENT_SHA256 =
  "7959de32cecce926bd174b9efd83c6fee8c2db4415d6897aa5021aad82d458f6";
export const AUTHORIZATION_POLICY_V34_VERSION = 34;
export const AUTHORIZATION_POLICY_V34_CONTENT_SHA256 =
  "8a2ac60ffda094077a1d9426c570c5f1992a0d46c21244e72a8b49b9b96294af";
export const AUTHORIZATION_POLICY_V35_VERSION = 35;
export const AUTHORIZATION_POLICY_V35_CONTENT_SHA256 =
  "5d7ae413cdb78d2c1160f29371e2253d1f5a45589b791ad13b5cf8322dfa31d5";
export const AUTHORIZATION_POLICY_V36_VERSION = 36;
export const AUTHORIZATION_POLICY_V36_CONTENT_SHA256 =
  "fabb43c32a5320e1a4c6bdbf9c86928f2765c3d602a8336e6106178453ee470d";
export const AUTHORIZATION_POLICY_V37_VERSION = 37;
export const AUTHORIZATION_POLICY_V37_CONTENT_SHA256 =
  "d17e86e525bef2a2bd7616a60ad53765da18c030501b7d7570aa21de1a2d0435";
export const AUTHORIZATION_POLICY_V38_VERSION = 38;
export const AUTHORIZATION_POLICY_V38_CONTENT_SHA256 =
  "2e09e00f7b2f0759b76d8b50f4d46f3a392207c6dbf57cb6a1cf1dbd9adaaf68";
export const AUTHORIZATION_POLICY_V39_VERSION = 39;
export const AUTHORIZATION_POLICY_V39_CONTENT_SHA256 =
  "50b0a384c3e96cab0856048929187a4a2bf4b9e3e8ae0e7eabc8b786b87cea59";
export const AUTHORIZATION_POLICY_V40_VERSION = 40;
export const AUTHORIZATION_POLICY_V40_CONTENT_SHA256 =
  "14fb3053420727928c0b8ebe1c2675644e09bab2292d19fb00ef53acb5d1b042";
export const AUTHORIZATION_POLICY_V41_VERSION = 41;
export const AUTHORIZATION_POLICY_V41_CONTENT_SHA256 =
  "91c9d6f474fca5a9792f1f776647b93700fabc1b915ac0c9b8e885deece5bb5c";
export const AUTHORIZATION_POLICY_V42_VERSION = 42;
export const AUTHORIZATION_POLICY_V42_CONTENT_SHA256 =
  "abb5ebd9cfcccad626c59758b373adbdf5653f06d0bd3bd62be27532113ed456";
export const AUTHORIZATION_POLICY_V43_VERSION = 43;
export const AUTHORIZATION_POLICY_V43_CONTENT_SHA256 =
  "419e7ed64caffe159bcc62fc6fce44ef38215b856fd13160b03beca3b6ec2ca9";
export const AUTHORIZATION_POLICY_V44_VERSION = 44;
export const AUTHORIZATION_POLICY_V44_CONTENT_SHA256 =
  "eb617a43cccc25cc22fe7cb47e7c1433affdd49a2c5a73032c2cceaa3f381026";
export const AUTHORIZATION_POLICY_V45_VERSION = 45;
export const AUTHORIZATION_POLICY_V45_CONTENT_SHA256 =
  "77a85346c78b9b8a1512968b2a0b9a68cf3be7fbaa3c68d5da4db006c27dfcd8";
export const AUTHORIZATION_POLICY_V46_VERSION = 46;
export const AUTHORIZATION_POLICY_V46_CONTENT_SHA256 =
  "e02b2e6a0139c81d210f4f8b8d278cc7254675ca51657a1dbf354c6473b72510";
export const AUTHORIZATION_POLICY_V47_VERSION = 47;
export const AUTHORIZATION_POLICY_V47_CONTENT_SHA256 =
  "7a89dde2ca3c0e86211771fc950703d0a39855f5b98780d4d9e390b50c0327ae";
export const AUTHORIZATION_POLICY_VERSION = AUTHORIZATION_POLICY_V47_VERSION;
export const AUTHORIZATION_POLICY_CONTENT_SHA256 = AUTHORIZATION_POLICY_V47_CONTENT_SHA256;

type WorkforceAuthorizationRole = "OWNER" | WorkforceRole;
type SessionStatus = "ACTIVE" | "REVOKED" | "EXPIRED";
const trustedPrincipalMarker: unique symbol = Symbol("trusted-authorization-principal");
const trustedAuthorizationFactsMarker: unique symbol = Symbol("trusted-authorization-facts");

interface TrustedPrincipalMarker {
  readonly [trustedPrincipalMarker]: true;
}

export interface WorkforceAuthorizationPrincipal extends TrustedPrincipalMarker {
  type: "WORKFORCE";
  sessionStatus: SessionStatus;
  factsStatus: "FRESH" | "STALE" | "MISSING" | "TAMPERED";
  context: WorkforcePrincipalContext;
  authorizationFactHash: string;
}

export interface CustomerAuthorizationPrincipal extends TrustedPrincipalMarker {
  type: "CUSTOMER";
  id: string;
  tenantId: string;
  storeId: string;
  sessionStatus: SessionStatus;
  sessionVersion: number;
}

export interface KioskAuthorizationPrincipal extends TrustedPrincipalMarker {
  type: "KIOSK";
  id: string;
  tenantId: string;
  storeId: string;
  tableId: string;
  bindingVersion: number;
  bindingStatus: "ACTIVE" | "REVOKED" | "INVALID";
}

export interface SupportAuthorizationGrant {
  grantId: string;
  version: number;
  storeId: string;
  resource: string;
  action: string;
  resourceId?: string | null;
  status: "ACTIVE" | "REVOKED";
  validFrom: string;
  validUntil: string;
}

export interface SupportAuthorizationPrincipal extends TrustedPrincipalMarker {
  type: "SUPPORT";
  id: string;
  tenantId: string;
  sessionStatus: SessionStatus;
  grants: SupportAuthorizationGrant[];
}

export interface ServiceAuthorizationPrincipal extends TrustedPrincipalMarker {
  type: "SERVICE";
  id: string;
  tenantId: string;
  storeId: string;
  credentialStatus: "ACTIVE" | "REVOKED" | "EXPIRED";
  credentialVersion: number;
  scopes: Array<{ resource: string; action: string }>;
}

export type AuthorizationEvaluationPrincipal =
  | WorkforceAuthorizationPrincipal
  | CustomerAuthorizationPrincipal
  | KioskAuthorizationPrincipal
  | SupportAuthorizationPrincipal
  | ServiceAuthorizationPrincipal;

export interface TrustedAuthorizationFacts {
  readonly conditions: readonly AuthorizationCondition[];
  readonly [trustedAuthorizationFactsMarker]: true;
}

export interface AuthorizationEvaluationInput {
  request: AuthorizationRequest;
  principal: AuthorizationEvaluationPrincipal;
  trustedFacts?: TrustedAuthorizationFacts;
  decidedAt: string;
}

export function createServerAuthorizationFacts(
  conditions: readonly AuthorizationCondition[],
): TrustedAuthorizationFacts {
  const normalized = deepCloneAndFreeze(
    conditions.map((condition) => ({ code: condition.code, value: condition.value })),
  );
  return Object.freeze({
    conditions: normalized,
    [trustedAuthorizationFactsMarker]: true as const,
  });
}

export function createWorkforceAuthorizationPrincipal(
  input: Omit<WorkforceAuthorizationPrincipal, "type" | typeof trustedPrincipalMarker>,
): WorkforceAuthorizationPrincipal {
  return trustedPrincipal({ type: "WORKFORCE", ...input });
}

export function createCustomerAuthorizationPrincipal(
  input: Omit<CustomerAuthorizationPrincipal, "type" | typeof trustedPrincipalMarker>,
): CustomerAuthorizationPrincipal {
  return trustedPrincipal({ type: "CUSTOMER", ...input });
}

export function createKioskAuthorizationPrincipal(
  input: Omit<KioskAuthorizationPrincipal, "type" | typeof trustedPrincipalMarker>,
): KioskAuthorizationPrincipal {
  return trustedPrincipal({ type: "KIOSK", ...input });
}

export function createSupportAuthorizationPrincipal(
  input: Omit<SupportAuthorizationPrincipal, "type" | typeof trustedPrincipalMarker>,
): SupportAuthorizationPrincipal {
  return trustedPrincipal({ type: "SUPPORT", ...input });
}

export function createServiceAuthorizationPrincipal(
  input: Omit<ServiceAuthorizationPrincipal, "type" | typeof trustedPrincipalMarker>,
): ServiceAuthorizationPrincipal {
  return trustedPrincipal({ type: "SERVICE", ...input });
}

function trustedPrincipal<T extends object>(input: T): T & TrustedPrincipalMarker {
  return Object.freeze({
    ...deepCloneAndFreeze(input),
    [trustedPrincipalMarker]: true as const,
  });
}

function deepCloneAndFreeze<T>(value: T): T {
  if (Array.isArray(value)) {
    return Object.freeze(value.map((item) => deepCloneAndFreeze(item))) as T;
  }
  if (value !== null && typeof value === "object") {
    const clone = Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, item]) => [
        key,
        deepCloneAndFreeze(item),
      ]),
    );
    return Object.freeze(clone) as T;
  }
  return value;
}

interface WorkforceRule {
  ruleId: string;
  roles: WorkforceAuthorizationRole[];
  resource: string;
  action: string;
  effect: Exclude<AuthorizationEffect, "DENY">;
  selfOnly?: boolean;
  approvalLevelRequired?: boolean;
  approvalApplicantRelation?: "SELF" | "DIFFERENT";
  orderCashRefundApplicantOnly?: boolean;
  personalSessionRequired?: boolean;
  workforcePersonalSessionRequired?: boolean;
  serviceDutyActiveRequired?: boolean;
  serviceRouteAckAllowedRequired?: boolean;
  serviceRequestTransferAllowedRequired?: boolean;
}

const workforceRules: WorkforceRule[] = [
  rule("owner-dashboard-read", ["OWNER"], "OWNER_DASHBOARD", "READ"),
  rule("owner-store-read", ["OWNER"], "STORE_CONFIGURATION", "READ"),
  rule("owner-store-update", ["OWNER"], "STORE_CONFIGURATION", "UPDATE"),
  rule("owner-workforce-read", ["OWNER"], "WORKFORCE_PERSON", "READ"),
  rule("owner-workforce-create", ["OWNER"], "WORKFORCE_PERSON", "CREATE"),
  rule("owner-workforce-update", ["OWNER"], "WORKFORCE_PERSON", "UPDATE"),
  rule("owner-workforce-disable", ["OWNER"], "WORKFORCE_PERSON", "DISABLE"),
  rule("owner-approval-read", ["OWNER"], "APPROVAL", "READ"),
  rule("owner-approval-decide", ["OWNER"], "APPROVAL", "DECIDE"),
  rule("owner-report-read", ["OWNER"], "REPORT", "READ"),
  rule("owner-payroll-read", ["OWNER"], "PAYROLL", "READ"),
  rule("owner-chain-read", ["OWNER"], "CHAIN", "READ"),
  rule("owner-shift-read", ["OWNER"], "SHIFT", "READ"),
  rule("owner-shift-close", ["OWNER"], "SHIFT", "CLOSE"),
  rule("owner-table-read", ["OWNER"], "TABLE_SESSION", "READ"),
  rule("owner-order-read", ["OWNER"], "ORDER", "READ"),
  rule("owner-payment-read", ["OWNER"], "PAYMENT", "READ"),
  rule("owner-member-read", ["OWNER"], "MEMBER_BALANCE", "READ"),
  rule("owner-product-manage", ["OWNER"], "PRODUCT", "MANAGE"),
  rule("owner-inventory-read", ["OWNER"], "INVENTORY", "READ"),
  ruleWithApproval("owner-inventory-adjust", ["OWNER"], "INVENTORY", "ADJUST"),
  rule("owner-coach-read", ["OWNER"], "COACH_SERVICE", "READ"),
  rule("owner-commission-read", ["OWNER"], "COACH_COMMISSION", "READ"),

  rule("manager-store-read", ["MANAGER"], "STORE_CONFIGURATION", "READ"),
  rule("manager-store-update", ["MANAGER"], "STORE_CONFIGURATION", "UPDATE"),
  rule("manager-workforce-read", ["MANAGER"], "WORKFORCE_PERSON", "READ"),
  rule("manager-approval-read", ["MANAGER"], "APPROVAL", "READ"),
  rule("manager-approval-decide", ["MANAGER"], "APPROVAL", "DECIDE"),
  rule("manager-report-read", ["MANAGER"], "REPORT", "READ"),
  rule("manager-shift-read", ["MANAGER"], "SHIFT", "READ"),
  rule("manager-shift-open", ["MANAGER"], "SHIFT", "OPEN"),
  rule("manager-shift-close", ["MANAGER"], "SHIFT", "CLOSE"),
  rule("manager-table-read", ["MANAGER"], "TABLE_SESSION", "READ"),
  rule("manager-table-operate", ["MANAGER"], "TABLE_SESSION", "OPERATE"),
  rule("manager-order-read", ["MANAGER"], "ORDER", "READ"),
  rule("manager-payment-read", ["MANAGER"], "PAYMENT", "READ"),
  rule("manager-payment-collect", ["MANAGER"], "PAYMENT", "COLLECT"),
  rule("manager-member-read", ["MANAGER"], "MEMBER_BALANCE", "READ"),
  rule("manager-product-manage", ["MANAGER"], "PRODUCT", "MANAGE"),
  rule("manager-inventory-read", ["MANAGER"], "INVENTORY", "READ"),
  ruleWithApproval("manager-inventory-adjust", ["MANAGER"], "INVENTORY", "ADJUST"),
  rule("manager-coach-read", ["MANAGER"], "COACH_SERVICE", "READ"),
  rule("manager-coach-assign", ["MANAGER"], "COACH_SERVICE", "ASSIGN"),
  rule("manager-coach-end", ["MANAGER"], "COACH_SERVICE", "END"),
  rule("manager-service-request-read", ["MANAGER"], "SERVICE_REQUEST", "READ"),
  rule("manager-service-request-complete", ["MANAGER"], "SERVICE_REQUEST", "COMPLETE"),

  rule("cashier-table-read", ["CASHIER"], "TABLE_SESSION", "READ"),
  rule("cashier-table-operate", ["CASHIER"], "TABLE_SESSION", "OPERATE"),
  rule("cashier-order-read", ["CASHIER"], "ORDER", "READ"),
  rule("cashier-order-create", ["CASHIER"], "ORDER", "CREATE"),
  rule("cashier-order-update", ["CASHIER"], "ORDER", "UPDATE"),
  rule("cashier-payment-read", ["CASHIER"], "PAYMENT", "READ"),
  rule("cashier-payment-collect", ["CASHIER"], "PAYMENT", "COLLECT"),
  approvalRule(
    "cashier-payment-refund",
    ["CASHIER"],
    "PAYMENT",
    "REQUEST_REFUND",
    "MANAGER_OR_OWNER_APPROVAL",
  ),
  rule("cashier-member-read", ["CASHIER"], "MEMBER_BALANCE", "READ"),
  rule("cashier-product-sell", ["CASHIER"], "PRODUCT", "SELL"),
  rule("cashier-coach-read", ["CASHIER"], "COACH_SERVICE", "READ"),
  rule("cashier-coach-assign", ["CASHIER"], "COACH_SERVICE", "ASSIGN"),
  rule("cashier-coach-end", ["CASHIER"], "COACH_SERVICE", "END"),
  rule("cashier-shift-read", ["CASHIER"], "SHIFT", "READ"),
  rule("cashier-shift-open", ["CASHIER"], "SHIFT", "OPEN"),
  rule("cashier-shift-handover", ["CASHIER"], "SHIFT", "HANDOVER"),
  rule("cashier-service-request-read", ["CASHIER"], "SERVICE_REQUEST", "READ"),

  rule("waiter-order-create", ["WAITER"], "ORDER", "CREATE"),
  rule("waiter-product-sell", ["WAITER"], "PRODUCT", "SELL"),
  rule("waiter-service-request-read", ["WAITER"], "SERVICE_REQUEST", "READ"),
  rule("waiter-service-request-ack", ["WAITER"], "SERVICE_REQUEST", "ACKNOWLEDGE"),
  rule("waiter-service-request-complete", ["WAITER"], "SERVICE_REQUEST", "COMPLETE"),
  rule("waiter-coach-request", ["WAITER"], "COACH_SERVICE", "REQUEST"),
  rule("waiter-table-light", ["WAITER"], "TABLE_DEVICE", "SET_LIGHT"),

  selfRule("coach-profile-read", "COACH_PROFILE", "READ"),
  selfRule("coach-shift-check-in", "COACH_SHIFT", "CHECK_IN"),
  selfRule("coach-availability-update", "COACH_SHIFT", "SET_AVAILABILITY"),
  selfRule("coach-service-read", "COACH_SERVICE", "READ"),
  selfRule("coach-service-start", "COACH_SERVICE", "START"),
  selfRule("coach-service-request-end", "COACH_SERVICE", "REQUEST_END"),
  selfRule("coach-commission-read", "COACH_COMMISSION", "READ"),
];

const workforceRulesV2: WorkforceRule[] = [
  ...workforceRules,
  rule(
    "owner-workforce-migration-conflict-read",
    ["OWNER"],
    "WORKFORCE_MIGRATION_CONFLICT",
    "READ",
  ),
];

const workforceRulesV3: WorkforceRule[] = [
  ...workforceRulesV2,
  rule("manager-commission-read", ["MANAGER"], "COACH_COMMISSION", "READ"),
];

const workforceRulesV4: WorkforceRule[] = [
  ...workforceRulesV3,
  rule("owner-member-sensitive-read", ["OWNER"], "MEMBER_SENSITIVE_PROFILE", "READ"),
  rule("manager-member-sensitive-read", ["MANAGER"], "MEMBER_SENSITIVE_PROFILE", "READ"),
];

const workforceRulesV5: WorkforceRule[] = [
  ...workforceRulesV4,
  rule("owner-service-request-read", ["OWNER"], "SERVICE_REQUEST", "READ"),
];

const workforceRulesV6: WorkforceRule[] = [
  ...workforceRulesV5,
  rule("owner-product-catalog-read", ["OWNER"], "PRODUCT_CATALOG", "READ"),
  rule("manager-product-catalog-read", ["MANAGER"], "PRODUCT_CATALOG", "READ"),
  rule("cashier-product-catalog-read", ["CASHIER"], "PRODUCT_CATALOG", "READ"),
];

const workforceRulesV7: WorkforceRule[] = [
  ...workforceRulesV6,
  rule("owner-store-connectivity-read", ["OWNER"], "STORE_CONNECTIVITY", "READ"),
  rule("manager-store-connectivity-read", ["MANAGER"], "STORE_CONNECTIVITY", "READ"),
  rule("cashier-store-connectivity-read", ["CASHIER"], "STORE_CONNECTIVITY", "READ"),
  rule("waiter-store-connectivity-read", ["WAITER"], "STORE_CONNECTIVITY", "READ"),
  rule("coach-store-connectivity-read", ["COACH"], "STORE_CONNECTIVITY", "READ"),
];

const workforceRulesV8: WorkforceRule[] = [
  ...workforceRulesV7,
  rule("owner-store-device-read", ["OWNER"], "STORE_DEVICE", "READ"),
  rule("manager-store-device-read", ["MANAGER"], "STORE_DEVICE", "READ"),
  rule("cashier-store-device-read", ["CASHIER"], "STORE_DEVICE", "READ"),
];

const workforceRulesV9: WorkforceRule[] = [
  ...workforceRulesV8,
  rule("owner-order-reprint-receipt", ["OWNER"], "ORDER", "REPRINT_RECEIPT"),
  rule("manager-order-reprint-receipt", ["MANAGER"], "ORDER", "REPRINT_RECEIPT"),
  rule("cashier-order-reprint-receipt", ["CASHIER"], "ORDER", "REPRINT_RECEIPT"),
];

const workforceRulesV10: WorkforceRule[] = [
  ...workforceRulesV9,
  rule("owner-diagnostic-read-redacted", ["OWNER"], "DIAGNOSTIC", "READ_REDACTED"),
  rule("manager-diagnostic-read-redacted", ["MANAGER"], "DIAGNOSTIC", "READ_REDACTED"),
];

const workforceRulesV11: WorkforceRule[] = [
  ...workforceRulesV10,
  rule("owner-member-sensitive-update", ["OWNER"], "MEMBER_SENSITIVE_PROFILE", "UPDATE"),
  rule("manager-member-sensitive-update", ["MANAGER"], "MEMBER_SENSITIVE_PROFILE", "UPDATE"),
];

const workforceRulesV12: WorkforceRule[] = [
  ...workforceRulesV11,
  rule("owner-workforce-account-disable", ["OWNER"], "WORKFORCE_ACCOUNT", "DISABLE"),
];

const workforceRulesV13: WorkforceRule[] = [
  ...workforceRulesV12,
  rule("owner-member-sensitive-create", ["OWNER"], "MEMBER_SENSITIVE_PROFILE", "CREATE"),
  rule("manager-member-sensitive-create", ["MANAGER"], "MEMBER_SENSITIVE_PROFILE", "CREATE"),
  rule("cashier-member-sensitive-create", ["CASHIER"], "MEMBER_SENSITIVE_PROFILE", "CREATE"),
];

const workforceRulesV14: WorkforceRule[] = [
  ...workforceRulesV13,
  rule("owner-manual-review-read", ["OWNER"], "MANUAL_REVIEW", "READ"),
  rule("manager-manual-review-read", ["MANAGER"], "MANUAL_REVIEW", "READ"),
  rule("cashier-manual-review-read", ["CASHIER"], "MANUAL_REVIEW", "READ"),
];

const workforceRulesV15: WorkforceRule[] = [
  ...workforceRulesV14,
  rule("manager-workforce-disable-frontline", ["MANAGER"], "WORKFORCE_PERSON", "DISABLE"),
];

const workforceRulesV16: WorkforceRule[] = [
  ...workforceRulesV15,
  rule("manager-workforce-rehire-frontline", ["MANAGER"], "WORKFORCE_PERSON", "CREATE"),
];

const workforceRulesV17: WorkforceRule[] = [
  ...workforceRulesV16,
  rule("manager-workforce-update-frontline", ["MANAGER"], "WORKFORCE_PERSON", "UPDATE"),
];

const workforceRulesV18: WorkforceRule[] = [
  ...workforceRulesV17,
  rule("owner-workforce-account-create", ["OWNER"], "WORKFORCE_ACCOUNT", "CREATE"),
  rule("manager-workforce-account-create", ["MANAGER"], "WORKFORCE_ACCOUNT", "CREATE"),
];

const workforceRulesV19: WorkforceRule[] = [
  ...workforceRulesV18.filter(
    (candidate) =>
      !(candidate.resource === "APPROVAL" && candidate.action === "DECIDE") &&
      candidate.ruleId !== "cashier-payment-refund",
  ),
  {
    ...approvalRule(
      "cashier-payment-refund",
      ["CASHIER"],
      "PAYMENT",
      "REQUEST_REFUND",
      "MANAGER_OR_OWNER_APPROVAL",
    ),
    orderCashRefundApplicantOnly: true,
  },
  approvalApplicantRule("owner-approval-decide", ["OWNER"], "DECIDE", "DIFFERENT"),
  approvalApplicantRule("manager-approval-decide", ["MANAGER"], "DECIDE", "DIFFERENT"),
  approvalApplicantRule("cashier-approval-read-self", ["CASHIER"], "READ_SELF", "SELF"),
  approvalApplicantRule("cashier-approval-cancel-self", ["CASHIER"], "CANCEL_SELF", "SELF"),
];

const workforceRulesV20: WorkforceRule[] = [
  ...workforceRulesV19,
  {
    ...approvalApplicantRule("owner-approval-execute", ["OWNER"], "EXECUTE", "DIFFERENT"),
    personalSessionRequired: true,
  },
  {
    ...approvalApplicantRule("manager-approval-execute", ["MANAGER"], "EXECUTE", "DIFFERENT"),
    personalSessionRequired: true,
  },
];

const workforceRulesV21: WorkforceRule[] = [
  ...workforceRulesV20.filter((candidate) => candidate.ruleId !== "waiter-service-request-ack"),
  rule("owner-service-duty-read", ["OWNER"], "SERVICE_DUTY", "READ"),
  rule("manager-service-duty-read", ["MANAGER"], "SERVICE_DUTY", "READ"),
  rule("manager-service-duty-update", ["MANAGER"], "SERVICE_DUTY", "UPDATE"),
  rule("manager-service-request-ack", ["MANAGER"], "SERVICE_REQUEST", "ACKNOWLEDGE"),
  rule("cashier-service-duty-read", ["CASHIER"], "SERVICE_DUTY", "READ"),
  rule("cashier-service-duty-assume", ["CASHIER"], "SERVICE_DUTY", "ASSUME"),
  rule("cashier-service-duty-release", ["CASHIER"], "SERVICE_DUTY", "RELEASE"),
  rule("waiter-service-duty-read", ["WAITER"], "SERVICE_DUTY", "READ"),
  {
    ...rule("waiter-service-request-ack-routed", ["WAITER"], "SERVICE_REQUEST", "ACKNOWLEDGE"),
    serviceRouteAckAllowedRequired: true,
  },
  {
    ...rule(
      "cashier-service-request-ack-active-duty",
      ["CASHIER"],
      "SERVICE_REQUEST",
      "ACKNOWLEDGE",
    ),
    serviceDutyActiveRequired: true,
  },
  {
    ...rule(
      "cashier-service-request-complete-active-duty",
      ["CASHIER"],
      "SERVICE_REQUEST",
      "COMPLETE",
    ),
    serviceDutyActiveRequired: true,
  },
];

const workforceRulesV22: WorkforceRule[] = [
  ...workforceRulesV21,
  rule("manager-service-request-transfer", ["MANAGER"], "SERVICE_REQUEST", "TRANSFER"),
  {
    ...rule("waiter-service-request-transfer", ["WAITER"], "SERVICE_REQUEST", "TRANSFER"),
    serviceRequestTransferAllowedRequired: true,
  },
  {
    ...rule(
      "cashier-service-request-transfer-active-duty",
      ["CASHIER"],
      "SERVICE_REQUEST",
      "TRANSFER",
    ),
    serviceDutyActiveRequired: true,
    serviceRequestTransferAllowedRequired: true,
  },
];

const workforceRulesV23: WorkforceRule[] = [
  ...workforceRulesV22,
  rule("manager-table-cleaning-complete", ["MANAGER"], "TABLE_SESSION", "CONFIRM_CLEANING"),
  rule("cashier-table-cleaning-complete", ["CASHIER"], "TABLE_SESSION", "CONFIRM_CLEANING"),
  rule("waiter-table-cleaning-complete", ["WAITER"], "TABLE_SESSION", "CONFIRM_CLEANING"),
];

const workforceRulesV24: WorkforceRule[] = [
  ...workforceRulesV23,
  approvalRule(
    "owner-purchase-order-submit-approval",
    ["OWNER"],
    "PURCHASE_ORDER",
    "SUBMIT_APPROVAL",
    "MANAGER_OR_OWNER_APPROVAL",
  ),
  approvalRule(
    "manager-purchase-order-submit-approval",
    ["MANAGER"],
    "PURCHASE_ORDER",
    "SUBMIT_APPROVAL",
    "MANAGER_OR_OWNER_APPROVAL",
  ),
];

const workforceRulesV25: WorkforceRule[] = [
  ...workforceRulesV24,
  rule("owner-purchase-order-receive", ["OWNER"], "PURCHASE_ORDER", "RECEIVE"),
  rule("manager-purchase-order-receive", ["MANAGER"], "PURCHASE_ORDER", "RECEIVE"),
];

const workforceRulesV26: WorkforceRule[] = [
  ...workforceRulesV25,
  rule("owner-purchase-order-return", ["OWNER"], "PURCHASE_ORDER", "RETURN"),
  rule("manager-purchase-order-return", ["MANAGER"], "PURCHASE_ORDER", "RETURN"),
];

const workforceRulesV27: WorkforceRule[] = [
  ...workforceRulesV26,
  rule("owner-purchase-payable-reconcile", ["OWNER"], "PURCHASE_ORDER", "RECONCILE_PAYABLE"),
  rule("manager-purchase-payable-reconcile", ["MANAGER"], "PURCHASE_ORDER", "RECONCILE_PAYABLE"),
  rule("owner-supplier-payment-record", ["OWNER"], "PURCHASE_ORDER", "PAY_SUPPLIER"),
];

const workforceRulesV28: WorkforceRule[] = [
  ...workforceRulesV27,
  rule("owner-purchase-order-close-short", ["OWNER"], "PURCHASE_ORDER", "CLOSE_SHORT"),
  rule("manager-purchase-order-close-short", ["MANAGER"], "PURCHASE_ORDER", "CLOSE_SHORT"),
];

const workforceRulesV29: WorkforceRule[] = [
  ...workforceRulesV28,
  rule("owner-supplier-credit-record", ["OWNER"], "PURCHASE_ORDER", "RECORD_SUPPLIER_CREDIT"),
  rule("manager-supplier-credit-record", ["MANAGER"], "PURCHASE_ORDER", "RECORD_SUPPLIER_CREDIT"),
  rule("owner-supplier-refund-record", ["OWNER"], "PURCHASE_ORDER", "RECORD_SUPPLIER_REFUND"),
  rule("owner-supplier-payment-reverse", ["OWNER"], "PURCHASE_ORDER", "REVERSE_SUPPLIER_PAYMENT"),
];

const workforceRulesV30: WorkforceRule[] = [
  ...workforceRulesV29,
  approvalRule(
    "owner-group-buy-daily-reconciliation",
    ["OWNER"],
    "ORDER",
    "RECONCILE_GROUP_BUY",
    "MANAGER_OR_OWNER_APPROVAL",
  ),
  approvalRule(
    "manager-group-buy-daily-reconciliation",
    ["MANAGER"],
    "ORDER",
    "RECONCILE_GROUP_BUY",
    "MANAGER_OR_OWNER_APPROVAL",
  ),
];

const workforceRulesV31: WorkforceRule[] = [
  ...workforceRulesV30,
  rule(
    "workforce-announcement-read",
    ["OWNER", "MANAGER", "CASHIER", "WAITER", "COACH"],
    "ANNOUNCEMENT",
    "READ",
  ),
  rule(
    "workforce-announcement-acknowledge",
    ["OWNER", "MANAGER", "CASHIER", "WAITER", "COACH"],
    "ANNOUNCEMENT",
    "ACKNOWLEDGE",
  ),
  rule(
    "workforce-announcement-reply",
    ["OWNER", "MANAGER", "CASHIER", "WAITER", "COACH"],
    "ANNOUNCEMENT",
    "REPLY",
  ),
  rule("owner-announcement-create", ["OWNER"], "ANNOUNCEMENT", "CREATE"),
  rule("owner-announcement-update", ["OWNER"], "ANNOUNCEMENT", "UPDATE"),
  rule("owner-announcement-publish", ["OWNER"], "ANNOUNCEMENT", "PUBLISH"),
  rule("owner-announcement-withdraw", ["OWNER"], "ANNOUNCEMENT", "WITHDRAW"),
  rule("owner-announcement-retry", ["OWNER"], "ANNOUNCEMENT", "RETRY_DELIVERY"),
  rule("manager-announcement-create", ["MANAGER"], "ANNOUNCEMENT", "CREATE"),
  rule("manager-announcement-update", ["MANAGER"], "ANNOUNCEMENT", "UPDATE"),
  rule("manager-announcement-publish", ["MANAGER"], "ANNOUNCEMENT", "PUBLISH"),
  rule("manager-announcement-withdraw", ["MANAGER"], "ANNOUNCEMENT", "WITHDRAW"),
  rule("manager-announcement-retry", ["MANAGER"], "ANNOUNCEMENT", "RETRY_DELIVERY"),
];

const workforceRulesV32: WorkforceRule[] = [
  ...workforceRulesV31,
  rule("manager-coach-correct-active", ["MANAGER"], "COACH_SERVICE", "CORRECT_ACTIVE"),
  rule("cashier-coach-correct-active", ["CASHIER"], "COACH_SERVICE", "CORRECT_ACTIVE"),
  selfRule("coach-service-correction-acknowledge", "COACH_SERVICE", "ACKNOWLEDGE_CORRECTION"),
];

const workforceRulesV33: WorkforceRule[] = [
  ...workforceRulesV32,
  rule(
    "workforce-store-operating-day-read",
    ["OWNER", "MANAGER", "CASHIER", "WAITER", "COACH"],
    "STORE_OPERATING_DAY",
    "READ",
  ),
  rule("manager-store-operating-day-open", ["MANAGER"], "STORE_OPERATING_DAY", "OPEN"),
];

const workforceRulesV34: WorkforceRule[] = [
  ...workforceRulesV33,
  rule(
    "manager-store-operating-day-start-closing",
    ["MANAGER"],
    "STORE_OPERATING_DAY",
    "START_CLOSING",
  ),
  rule(
    "manager-store-operating-day-acknowledge-legacy",
    ["MANAGER"],
    "STORE_OPERATING_DAY",
    "ACKNOWLEDGE_LEGACY",
  ),
  rule(
    "owner-store-operating-day-acknowledge-legacy",
    ["OWNER"],
    "STORE_OPERATING_DAY",
    "ACKNOWLEDGE_LEGACY",
  ),
  rule(
    "manager-store-operating-day-complete-closing",
    ["MANAGER"],
    "STORE_OPERATING_DAY",
    "COMPLETE_CLOSING",
  ),
];

const workforceRulesV35: WorkforceRule[] = [
  ...workforceRulesV34,
  rule(
    "workforce-attendance-read-self",
    ["MANAGER", "CASHIER", "WAITER", "COACH"],
    "WORKFORCE_ATTENDANCE",
    "READ_SELF",
  ),
  rule(
    "workforce-attendance-clock-self",
    ["MANAGER", "CASHIER", "WAITER", "COACH"],
    "WORKFORCE_ATTENDANCE",
    "CLOCK_SELF",
  ),
  rule(
    "workforce-attendance-request-correction-self",
    ["MANAGER", "CASHIER", "WAITER", "COACH"],
    "WORKFORCE_ATTENDANCE",
    "REQUEST_CORRECTION_SELF",
  ),
  rule(
    "workforce-attendance-acknowledge-correction-self",
    ["MANAGER", "CASHIER", "WAITER", "COACH"],
    "WORKFORCE_ATTENDANCE",
    "ACKNOWLEDGE_CORRECTION_SELF",
  ),
  rule("manager-workforce-attendance-read", ["MANAGER"], "WORKFORCE_ATTENDANCE", "READ_MANAGED"),
  rule(
    "manager-workforce-attendance-create-schedule",
    ["MANAGER"],
    "WORKFORCE_ATTENDANCE",
    "CREATE_SCHEDULE",
  ),
  rule(
    "manager-workforce-attendance-decide-correction",
    ["MANAGER"],
    "WORKFORCE_ATTENDANCE",
    "DECIDE_CORRECTION",
  ),
];

const workforceRulesV36: WorkforceRule[] = [
  ...workforceRulesV35,
  {
    ...rule(
      "workforce-account-wechat-rebind-self",
      ["MANAGER", "CASHIER", "WAITER", "COACH"],
      "WORKFORCE_ACCOUNT",
      "REBIND_WECHAT_SELF",
    ),
    workforcePersonalSessionRequired: true,
  },
];

const workforceRulesV37: WorkforceRule[] = [
  ...workforceRulesV36,
  {
    ...rule(
      "workforce-account-phone-change-self",
      ["MANAGER", "CASHIER", "WAITER", "COACH"],
      "WORKFORCE_ACCOUNT",
      "CHANGE_PHONE_SELF",
    ),
    workforcePersonalSessionRequired: true,
  },
];

const workforceRulesV38: WorkforceRule[] = [
  ...workforceRulesV37,
  rule(
    "workforce-store-device-resolve-manually",
    ["MANAGER", "CASHIER"],
    "STORE_DEVICE",
    "RESOLVE_MANUALLY",
  ),
];

const workforceRulesV39: WorkforceRule[] = [
  ...workforceRulesV38,
  rule(
    "workforce-group-buy-redemption-read",
    ["MANAGER", "CASHIER"],
    "GROUP_BUY_REDEMPTION",
    "READ",
  ),
  rule(
    "workforce-group-buy-redemption-operate",
    ["MANAGER", "CASHIER"],
    "GROUP_BUY_REDEMPTION",
    "OPERATE",
  ),
];

const workforceRulesV40: WorkforceRule[] = [
  ...workforceRulesV39,
  rule("manager-shift-handover", ["MANAGER"], "SHIFT", "HANDOVER"),
  rule("manager-coach-shift-check-in", ["MANAGER"], "COACH_SHIFT", "CHECK_IN"),
  rule("manager-coach-availability-update", ["MANAGER"], "COACH_SHIFT", "SET_AVAILABILITY"),
  rule("manager-coach-service-replace", ["MANAGER"], "COACH_SERVICE", "REPLACE"),
];

const workforceRulesV41: WorkforceRule[] = [
  ...workforceRulesV40,
  rule("owner-member-recharge-create", ["OWNER"], "MEMBER_RECHARGE", "CREATE"),
  rule("manager-member-recharge-create", ["MANAGER"], "MEMBER_RECHARGE", "CREATE"),
  rule("cashier-member-recharge-create", ["CASHIER"], "MEMBER_RECHARGE", "CREATE"),
  rule("owner-member-recharge-reconcile", ["OWNER"], "MEMBER_RECHARGE", "RECONCILE"),
  rule("manager-member-recharge-reconcile", ["MANAGER"], "MEMBER_RECHARGE", "RECONCILE"),
];

const workforceRulesV42: WorkforceRule[] = [
  ...workforceRulesV41,
  rule(
    "workforce-group-buy-manual-fulfillment-record",
    ["OWNER", "MANAGER", "CASHIER"],
    "GROUP_BUY_REDEMPTION",
    "RECORD_MANUAL",
  ),
];

const workforceRulesV43: WorkforceRule[] = [
  ...workforceRulesV42,
  rule("workforce-customer-storage-operate", ["MANAGER", "CASHIER"], "CUSTOMER_STORAGE", "OPERATE"),
];

const workforceRulesV44: WorkforceRule[] = [
  ...workforceRulesV43,
  rule("workforce-customer-rental-operate", ["MANAGER", "CASHIER"], "CUSTOMER_RENTAL", "OPERATE"),
];

const workforceRulesV45: WorkforceRule[] = [
  ...workforceRulesV44,
  rule(
    "workforce-payroll-read-self",
    ["MANAGER", "CASHIER", "WAITER", "COACH"],
    "WORKFORCE_PAYROLL",
    "READ_SELF",
  ),
  rule("owner-workforce-payroll-read", ["OWNER"], "WORKFORCE_PAYROLL", "READ_MANAGED"),
  rule("manager-workforce-payroll-read", ["MANAGER"], "WORKFORCE_PAYROLL", "READ_MANAGED"),
  rule("owner-workforce-payroll-create", ["OWNER"], "WORKFORCE_PAYROLL", "CREATE_DRAFT"),
  rule("owner-workforce-payroll-revise", ["OWNER"], "WORKFORCE_PAYROLL", "REVISE"),
  rule("manager-workforce-payroll-review", ["MANAGER"], "WORKFORCE_PAYROLL", "REVIEW"),
  rule(
    "workforce-payroll-respond-self",
    ["MANAGER", "CASHIER", "WAITER", "COACH"],
    "WORKFORCE_PAYROLL",
    "RESPOND_SELF",
  ),
  rule("owner-workforce-payroll-lock", ["OWNER"], "WORKFORCE_PAYROLL", "LOCK"),
  rule("owner-workforce-payroll-record-payment", ["OWNER"], "WORKFORCE_PAYROLL", "RECORD_PAYMENT"),
];

const workforceRulesV46: WorkforceRule[] = [
  ...workforceRulesV45,
  rule("owner-support-access-read", ["OWNER"], "SUPPORT_ACCESS", "READ"),
  rule("owner-support-access-create", ["OWNER"], "SUPPORT_ACCESS", "CREATE"),
  rule("owner-support-access-revoke", ["OWNER"], "SUPPORT_ACCESS", "REVOKE"),
];

const workforceRulesV47: WorkforceRule[] = [
  ...workforceRulesV46,
  approvalRule(
    "owner-manual-review-resolve",
    ["OWNER"],
    "MANUAL_REVIEW",
    "RESOLVE",
    "MANAGER_OR_OWNER_APPROVAL",
  ),
  approvalRule(
    "manager-manual-review-resolve",
    ["MANAGER"],
    "MANUAL_REVIEW",
    "RESOLVE",
    "MANAGER_OR_OWNER_APPROVAL",
  ),
];

const hardConstraintPairs = new Map<string, string>([
  ["IMMUTABLE_LEDGER:REWRITE", "hard-immutable-ledger-rewrite"],
  ["IMMUTABLE_LEDGER:UPDATE", "hard-immutable-ledger-update"],
  ["IMMUTABLE_LEDGER:DELETE", "hard-immutable-ledger-delete"],
  ["CREDENTIAL_SECRET:READ", "hard-credential-secret-read"],
  ["CREDENTIAL_SECRET:EXPORT", "hard-credential-secret-export"],
  ["TENANT_ISOLATION:BYPASS", "hard-tenant-isolation-bypass"],
]);

const authorizationSensitiveConditionCodes = new Set([
  "NO_PRODUCT_FACT",
  "NO_COACH_FACT",
  "NO_PAYMENT_FACT",
  "BUSINESS_REASON_PRESENT",
  "TARGET_COACH_ID",
  "TARGET_CUSTOMER_ID",
  "TARGET_TABLE_ID",
  "REQUIRED_APPROVAL_LEVEL",
  "APPROVAL_APPLICANT_IS_SELF",
  "APPROVAL_EXECUTOR_SESSION_IS_PERSONAL",
  "WORKFORCE_SESSION_IS_PERSONAL",
  "SERVICE_DUTY_ACTIVE",
  "SERVICE_ROUTE_ACK_ALLOWED",
  "SERVICE_REQUEST_TRANSFER_ALLOWED",
]);

const customerRules = new Set([
  "CUSTOMER_PROFILE:READ",
  "CUSTOMER_RESERVATION:CREATE",
  "CUSTOMER_RESERVATION:CANCEL",
  "CUSTOMER_ORDER:CREATE",
  "CUSTOMER_BENEFIT:READ",
]);
const kioskRules = new Set([
  "KIOSK_ORDER:CREATE",
  "KIOSK_SERVICE_REQUEST:CREATE",
  "KIOSK_COACH_REQUEST:CREATE",
  "KIOSK_CHECKOUT:REQUEST",
  "KIOSK_CONNECTIVITY:REPORT",
]);
const supportRules = new Set(["DIAGNOSTIC:READ_REDACTED", "RAW_LOG:READ"]);
const serviceRules = new Map<string, Set<string>>([
  ["projection_service", new Set(["WORKFORCE_PROJECTION:APPLY"])],
  ["payment_callback_service", new Set(["PAYMENT_CALLBACK:APPLY"])],
  ["device_command_service", new Set(["DEVICE_COMMAND:EXECUTE"])],
]);

function rule(
  ruleId: string,
  roles: WorkforceAuthorizationRole[],
  resource: string,
  action: string,
): WorkforceRule {
  return { ruleId, roles, resource, action, effect: "DIRECT" };
}

function approvalRule(
  ruleId: string,
  roles: WorkforceAuthorizationRole[],
  resource: string,
  action: string,
  effect: "MANAGER_OR_OWNER_APPROVAL" | "MANAGER_THEN_OWNER_APPROVAL",
): WorkforceRule {
  return { ruleId, roles, resource, action, effect };
}

function ruleWithApproval(
  ruleId: string,
  roles: WorkforceAuthorizationRole[],
  resource: string,
  action: string,
): WorkforceRule {
  return { ...rule(ruleId, roles, resource, action), approvalLevelRequired: true };
}

function approvalApplicantRule(
  ruleId: string,
  roles: WorkforceAuthorizationRole[],
  action: "READ_SELF" | "CANCEL_SELF" | "DECIDE" | "EXECUTE",
  relation: "SELF" | "DIFFERENT",
): WorkforceRule {
  return {
    ...rule(ruleId, roles, "APPROVAL", action),
    approvalApplicantRelation: relation,
  };
}

function selfRule(ruleId: string, resource: string, action: string): WorkforceRule {
  return { ...rule(ruleId, ["COACH"], resource, action), selfOnly: true };
}

interface DecisionTemplate {
  effect: Exclude<AuthorizationEffect, "DENY">;
  reasonCode:
    | "AUTHORIZATION_DIRECT"
    | "AUTHORIZATION_MANAGER_OR_OWNER_APPROVAL_REQUIRED"
    | "AUTHORIZATION_MANAGER_THEN_OWNER_APPROVAL_REQUIRED";
  message: string;
  nextStep: string;
}

const directTemplate: DecisionTemplate = {
  effect: "DIRECT",
  reasonCode: "AUTHORIZATION_DIRECT",
  message: "当前操作在您的职责范围内，可以直接执行。",
  nextStep: "可以继续操作，系统会记录本次行为。",
};
const oneLevelTemplate: DecisionTemplate = {
  effect: "MANAGER_OR_OWNER_APPROVAL",
  reasonCode: "AUTHORIZATION_MANAGER_OR_OWNER_APPROVAL_REQUIRED",
  message: "这项操作需要店长或老板确认后才能执行。",
  nextStep: "请提交申请并等待店长或老板确认，不要重复操作。",
};
const twoLevelTemplate: DecisionTemplate = {
  effect: "MANAGER_THEN_OWNER_APPROVAL",
  reasonCode: "AUTHORIZATION_MANAGER_THEN_OWNER_APPROVAL_REQUIRED",
  message: "这项操作需要先由店长确认，再由老板确认。",
  nextStep: "请提交两级申请；两次确认完成前不会执行业务变化。",
};

function decisionCommon(request: AuthorizationRequest, decidedAt: string) {
  return {
    requestId: request.requestId,
    scope: request.scope,
    resource: request.resource,
    action: request.action,
    policyVersion: request.policyVersion,
    policyContentSha256: request.policyContentSha256,
    projectionVersion: request.projectionVersion,
    identityVersion: request.identityVersion,
    bindingVersion: request.bindingVersion,
    projectionHash: request.projectionHash,
    authorizationFactHash: request.authorizationFactHash,
    decidedAt,
  };
}

function allowedDecision(
  request: AuthorizationRequest,
  decidedAt: string,
  template: DecisionTemplate,
  matchedRuleId: string,
  matchedBy: AuthorizationMatchedBy,
): AuthorizationDecision {
  const common = decisionCommon(request, decidedAt);
  if (template.effect === "DIRECT") {
    return {
      ...common,
      effect: "DIRECT",
      reasonCode: "AUTHORIZATION_DIRECT",
      message: template.message,
      nextStep: template.nextStep,
      matchedRuleId,
      matchedBy,
      canExecute: true,
    };
  }
  if (template.effect === "MANAGER_OR_OWNER_APPROVAL") {
    return {
      ...common,
      effect: "MANAGER_OR_OWNER_APPROVAL",
      reasonCode: "AUTHORIZATION_MANAGER_OR_OWNER_APPROVAL_REQUIRED",
      message: template.message,
      nextStep: template.nextStep,
      matchedRuleId,
      matchedBy,
      canExecute: false,
    };
  }
  return {
    ...common,
    effect: "MANAGER_THEN_OWNER_APPROVAL",
    reasonCode: "AUTHORIZATION_MANAGER_THEN_OWNER_APPROVAL_REQUIRED",
    message: template.message,
    nextStep: template.nextStep,
    matchedRuleId,
    matchedBy,
    canExecute: false,
  };
}

function denied(
  request: AuthorizationRequest,
  decidedAt: string,
  reasonCode: string,
  message: string,
  nextStep: string,
  matchedRuleId: string | null = null,
): AuthorizationDecision {
  return {
    ...decisionCommon(request, decidedAt),
    effect: "DENY",
    reasonCode,
    message,
    nextStep,
    matchedRuleId,
    matchedBy: null,
    canExecute: false,
  };
}

function conditionsByCode(
  conditions: readonly AuthorizationCondition[],
): Map<string, unknown> | null {
  const result = new Map<string, unknown>();
  for (const condition of conditions) {
    if (result.has(condition.code)) return null;
    result.set(condition.code, condition.value);
  }
  return result;
}

function validateCommonBoundary(
  input: AuthorizationEvaluationInput,
  policyVersion: number,
  policyContentSha256: string,
): AuthorizationDecision | null {
  const { request, principal, decidedAt } = input;
  if (
    principal === null ||
    typeof principal !== "object" ||
    principal[trustedPrincipalMarker] !== true
  ) {
    return denied(
      request,
      decidedAt,
      "AUTHORIZATION_PRINCIPAL_NOT_TRUSTED",
      "当前身份不是由服务器可信会话生成的，系统不会使用外部身份声明。",
      "请重新登录并从当前门店页面发起操作。",
    );
  }
  if (
    input.trustedFacts !== undefined &&
    (input.trustedFacts === null ||
      typeof input.trustedFacts !== "object" ||
      input.trustedFacts[trustedAuthorizationFactsMarker] !== true)
  ) {
    return denied(
      request,
      decidedAt,
      "AUTHORIZATION_SERVER_FACTS_NOT_TRUSTED",
      "这项操作缺少系统核验后的业务事实。",
      "请刷新页面后重试；系统会重新核对订单、支付、库存和人员状态。",
    );
  }
  if (request.conditions.some((item) => authorizationSensitiveConditionCodes.has(item.code))) {
    return denied(
      request,
      decidedAt,
      "AUTHORIZATION_UNTRUSTED_CONDITION",
      "这项权限条件不能由页面或调用方自行声明。",
      "请刷新页面，让服务器根据真实订单、门店和设备资料重新判断。",
    );
  }
  if (
    request.principal.type !== principal.type ||
    request.policyVersion !== policyVersion ||
    request.policyContentSha256 !== policyContentSha256
  ) {
    return denied(
      request,
      decidedAt,
      "AUTHORIZATION_VERSION_MISMATCH",
      "当前身份或权限规则已经变化，不能继续使用旧页面执行操作。",
      "请刷新页面并重新登录；系统不会使用旧权限继续处理。",
    );
  }
  const principalId = principal.type === "WORKFORCE" ? principal.context.account.id : principal.id;
  const principalTenantId =
    principal.type === "WORKFORCE" ? principal.context.tenantId : principal.tenantId;
  if (request.principal.id !== principalId || request.scope.tenantId !== principalTenantId) {
    return scopeMismatch(request, decidedAt);
  }
  const hardRuleId = hardConstraintPairs.get(`${request.resource}:${request.action}`);
  if (hardRuleId) {
    return denied(
      request,
      decidedAt,
      "AUTHORIZATION_HARD_CONSTRAINT",
      "这项操作会突破系统必须遵守的安全规则，任何角色都不能执行。",
      "请使用系统提供的更正、冲正或安全恢复流程，不能改写原始事实。",
      hardRuleId,
    );
  }
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(request, decidedAt);
  if (facts.get("REQUIRED_APPROVAL_LEVEL") === "HARD_DENY") {
    return denied(
      request,
      decidedAt,
      "AUTHORIZATION_HARD_CONSTRAINT",
      "当前业务条件触发了不可越过的安全限制。",
      "请停止当前操作并按页面说明处理原业务问题。",
    );
  }
  return null;
}

/** Frozen policy-v1 evaluator retained for historical audit replay after later policy releases. */
function decideAuthorizationV1(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V1_VERSION,
    AUTHORIZATION_POLICY_V1_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV2(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V2_VERSION,
    AUTHORIZATION_POLICY_V2_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV2,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV3(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V3_VERSION,
    AUTHORIZATION_POLICY_V3_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV3,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV4(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V4_VERSION,
    AUTHORIZATION_POLICY_V4_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV4,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV5(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V5_VERSION,
    AUTHORIZATION_POLICY_V5_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV5,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV6(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V6_VERSION,
    AUTHORIZATION_POLICY_V6_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV6,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV7(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V7_VERSION,
    AUTHORIZATION_POLICY_V7_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV7,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV8(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V8_VERSION,
    AUTHORIZATION_POLICY_V8_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV8,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV9(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V9_VERSION,
    AUTHORIZATION_POLICY_V9_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV9,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV10(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V10_VERSION,
    AUTHORIZATION_POLICY_V10_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV10,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV11(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V11_VERSION,
    AUTHORIZATION_POLICY_V11_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV11,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV12(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V12_VERSION,
    AUTHORIZATION_POLICY_V12_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV12,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV13(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V13_VERSION,
    AUTHORIZATION_POLICY_V13_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV13,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV14(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V14_VERSION,
    AUTHORIZATION_POLICY_V14_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV14,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV15(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V15_VERSION,
    AUTHORIZATION_POLICY_V15_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV15,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV16(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V16_VERSION,
    AUTHORIZATION_POLICY_V16_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV16,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV17(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V17_VERSION,
    AUTHORIZATION_POLICY_V17_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV17,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV18(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V18_VERSION,
    AUTHORIZATION_POLICY_V18_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV18,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV19(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V19_VERSION,
    AUTHORIZATION_POLICY_V19_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV19,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV20(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V20_VERSION,
    AUTHORIZATION_POLICY_V20_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV20,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV21(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V21_VERSION,
    AUTHORIZATION_POLICY_V21_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV21,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV22(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V22_VERSION,
    AUTHORIZATION_POLICY_V22_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV22,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV23(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V23_VERSION,
    AUTHORIZATION_POLICY_V23_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV23,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV24(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V24_VERSION,
    AUTHORIZATION_POLICY_V24_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV24,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV25(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V25_VERSION,
    AUTHORIZATION_POLICY_V25_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV25,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV26(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V26_VERSION,
    AUTHORIZATION_POLICY_V26_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV26,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV27(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V27_VERSION,
    AUTHORIZATION_POLICY_V27_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV27,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV28(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V28_VERSION,
    AUTHORIZATION_POLICY_V28_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV28,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV29(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V29_VERSION,
    AUTHORIZATION_POLICY_V29_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV29,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV30(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V30_VERSION,
    AUTHORIZATION_POLICY_V30_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV30,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV31(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V31_VERSION,
    AUTHORIZATION_POLICY_V31_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV31,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV32(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V32_VERSION,
    AUTHORIZATION_POLICY_V32_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV32,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV33(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V33_VERSION,
    AUTHORIZATION_POLICY_V33_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV33,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV34(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V34_VERSION,
    AUTHORIZATION_POLICY_V34_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV34,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV35(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V35_VERSION,
    AUTHORIZATION_POLICY_V35_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV35,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV36(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V36_VERSION,
    AUTHORIZATION_POLICY_V36_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV36,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV37(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V37_VERSION,
    AUTHORIZATION_POLICY_V37_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV37,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV38(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V38_VERSION,
    AUTHORIZATION_POLICY_V38_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV38,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV39(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V39_VERSION,
    AUTHORIZATION_POLICY_V39_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV39,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV40(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V40_VERSION,
    AUTHORIZATION_POLICY_V40_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV40,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV41(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V41_VERSION,
    AUTHORIZATION_POLICY_V41_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV41,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV42(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V42_VERSION,
    AUTHORIZATION_POLICY_V42_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV42,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV43(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V43_VERSION,
    AUTHORIZATION_POLICY_V43_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV43,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV44(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V44_VERSION,
    AUTHORIZATION_POLICY_V44_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV44,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV45(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V45_VERSION,
    AUTHORIZATION_POLICY_V45_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV45,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV46(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V46_VERSION,
    AUTHORIZATION_POLICY_V46_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV46,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

function decideAuthorizationV47(input: AuthorizationEvaluationInput): AuthorizationDecision {
  const commonDenial = validateCommonBoundary(
    input,
    AUTHORIZATION_POLICY_V47_VERSION,
    AUTHORIZATION_POLICY_V47_CONTENT_SHA256,
  );
  if (commonDenial) return commonDenial;
  const facts = conditionsByCode(input.trustedFacts?.conditions ?? []);
  if (!facts) return conditionInvalid(input.request, input.decidedAt);
  switch (input.principal.type) {
    case "WORKFORCE":
      return decideWorkforceAuthorization(
        input.request,
        input.principal,
        facts,
        input.decidedAt,
        workforceRulesV47,
      );
    case "CUSTOMER":
      return decideCustomerAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "KIOSK":
      return decideKioskAuthorization(input.request, input.principal, facts, input.decidedAt);
    case "SUPPORT":
      return decideSupportAuthorization(input.request, input.principal, input.decidedAt);
    case "SERVICE":
      return decideServiceAuthorization(input.request, input.principal, input.decidedAt);
  }
}

export function decideAuthorization(input: AuthorizationEvaluationInput): AuthorizationDecision {
  return decideAuthorizationV47(input);
}

function decideWorkforceAuthorization(
  request: AuthorizationRequest,
  principal: WorkforceAuthorizationPrincipal,
  facts: Map<string, unknown>,
  decidedAt: string,
  policyRules: readonly WorkforceRule[] = workforceRules,
): AuthorizationDecision {
  const context = principal.context;
  if (principal.sessionStatus !== "ACTIVE") return inactiveSession(request, decidedAt);
  if (principal.factsStatus !== "FRESH") {
    return denied(
      request,
      decidedAt,
      "AUTHORIZATION_FACTS_NOT_TRUSTED",
      "当前人员权限资料不是最新可信版本，系统已暂停放行。",
      "请等待门店重新取得最新人员资料后再试。",
    );
  }
  if (
    context.account.status !== "ACTIVE" ||
    context.person?.status !== "ACTIVE" ||
    context.resolutionStatus !== "RESOLVED" ||
    !context.currentStoreContext ||
    !affiliationIsCanonical(context.currentStoreContext, context.affiliations)
  ) {
    return denied(
      request,
      decidedAt,
      "AUTHORIZATION_IDENTITY_NOT_ACTIVE",
      "当前账号没有这家门店的有效在职或所有权关系。",
      "请联系老板核对任职；离职或已撤销身份不能继续使用旧会话。",
    );
  }
  if (
    request.projectionVersion !== context.projection.revision ||
    request.identityVersion !== context.account.identityVersion ||
    request.bindingVersion !== null ||
    request.projectionHash !== context.projection.contentSha256 ||
    request.authorizationFactHash !== principal.authorizationFactHash
  ) {
    return versionMismatch(request, decidedAt);
  }
  if (!request.scope.storeId || context.currentStoreContext.storeId !== request.scope.storeId) {
    return scopeMismatch(request, decidedAt);
  }

  const roles = new Set<WorkforceAuthorizationRole>(context.currentStoreContext.roles);
  if (context.currentStoreContext.ownershipId) roles.add("OWNER");
  if (request.resource === "TABLE_SESSION" && request.action === "VOID_ACCIDENTAL") {
    return decideAccidentalVoid(request, roles, facts, decidedAt);
  }
  const matchingRules = policyRules.filter(
    (candidate) =>
      candidate.resource === request.resource &&
      candidate.action === request.action &&
      candidate.roles.some((roleName) => roles.has(roleName)),
  );
  const applicable: Array<{ rule: WorkforceRule; role: WorkforceAuthorizationRole }> = [];
  let selfConditionMissing = false;
  let approvalApplicantConditionMissing = false;
  let approvalSelfDecisionForbidden = false;
  let approvalSelfExecutionForbidden = false;
  let approvalPersonalSessionConditionMissing = false;
  let approvalPersonalSessionRequired = false;
  let workforcePersonalSessionConditionMissing = false;
  let workforcePersonalSessionRequired = false;
  let orderCashRefundApplicantRoleConflict = false;
  let serviceDutyConditionMissing = false;
  let serviceDutyInactive = false;
  let serviceRouteAckConditionMissing = false;
  let serviceRouteAckNotAllowed = false;
  let serviceRequestTransferConditionMissing = false;
  let serviceRequestTransferNotAllowed = false;
  for (const candidate of matchingRules) {
    const matchedRole = candidate.roles.find((roleName) => roles.has(roleName));
    if (!matchedRole) continue;
    if (candidate.orderCashRefundApplicantOnly && (roles.has("OWNER") || roles.has("MANAGER"))) {
      orderCashRefundApplicantRoleConflict = true;
      continue;
    }
    if (candidate.approvalApplicantRelation) {
      const applicantIsSelf = facts.get("APPROVAL_APPLICANT_IS_SELF");
      if (typeof applicantIsSelf !== "boolean") {
        approvalApplicantConditionMissing = true;
        continue;
      }
      const relationMatches =
        candidate.approvalApplicantRelation === "SELF" ? applicantIsSelf : !applicantIsSelf;
      if (!relationMatches) {
        if (candidate.action === "DECIDE" && applicantIsSelf) {
          approvalSelfDecisionForbidden = true;
        }
        if (candidate.action === "EXECUTE" && applicantIsSelf) {
          approvalSelfExecutionForbidden = true;
        }
        continue;
      }
    }
    if (candidate.personalSessionRequired) {
      const personalSession = facts.get("APPROVAL_EXECUTOR_SESSION_IS_PERSONAL");
      if (typeof personalSession !== "boolean") {
        approvalPersonalSessionConditionMissing = true;
        continue;
      }
      if (!personalSession) {
        approvalPersonalSessionRequired = true;
        continue;
      }
    }
    if (candidate.workforcePersonalSessionRequired) {
      const personalSession = facts.get("WORKFORCE_SESSION_IS_PERSONAL");
      if (typeof personalSession !== "boolean") {
        workforcePersonalSessionConditionMissing = true;
        continue;
      }
      if (!personalSession) {
        workforcePersonalSessionRequired = true;
        continue;
      }
    }
    if (candidate.serviceDutyActiveRequired) {
      const serviceDutyActive = facts.get("SERVICE_DUTY_ACTIVE");
      if (typeof serviceDutyActive !== "boolean") {
        serviceDutyConditionMissing = true;
        continue;
      }
      if (!serviceDutyActive) {
        serviceDutyInactive = true;
        continue;
      }
    }
    if (candidate.serviceRouteAckAllowedRequired) {
      const serviceRouteAckAllowed = facts.get("SERVICE_ROUTE_ACK_ALLOWED");
      if (typeof serviceRouteAckAllowed !== "boolean") {
        serviceRouteAckConditionMissing = true;
        continue;
      }
      if (!serviceRouteAckAllowed) {
        serviceRouteAckNotAllowed = true;
        continue;
      }
    }
    if (candidate.serviceRequestTransferAllowedRequired) {
      const serviceRequestTransferAllowed = facts.get("SERVICE_REQUEST_TRANSFER_ALLOWED");
      if (typeof serviceRequestTransferAllowed !== "boolean") {
        serviceRequestTransferConditionMissing = true;
        continue;
      }
      if (!serviceRequestTransferAllowed) {
        serviceRequestTransferNotAllowed = true;
        continue;
      }
    }
    if (!candidate.selfOnly) {
      applicable.push({ rule: candidate, role: matchedRole });
      continue;
    }
    const coachId = context.currentStoreContext.coachId;
    const targetCoachId = facts.get("TARGET_COACH_ID");
    if (coachId && targetCoachId === coachId)
      applicable.push({ rule: candidate, role: matchedRole });
    else if (targetCoachId === undefined) selfConditionMissing = true;
  }
  if (applicable.length === 0) {
    if (
      selfConditionMissing ||
      approvalApplicantConditionMissing ||
      approvalPersonalSessionConditionMissing ||
      workforcePersonalSessionConditionMissing ||
      serviceDutyConditionMissing ||
      serviceRouteAckConditionMissing ||
      serviceRequestTransferConditionMissing
    ) {
      return conditionMissing(request, decidedAt);
    }
    if (approvalSelfExecutionForbidden) {
      return denied(
        request,
        decidedAt,
        "AUTHORIZATION_APPROVAL_SELF_EXECUTION_FORBIDDEN",
        "申请人不能执行自己提交的退款申请。",
        "请由同店其他使用个人账号登录的有权店长或老板执行。",
      );
    }
    if (approvalSelfDecisionForbidden) {
      return denied(
        request,
        decidedAt,
        "AUTHORIZATION_APPROVAL_SELF_DECISION_FORBIDDEN",
        "申请人不能审批自己提交的申请。",
        "请等待同店其他有权店长或老板处理，系统不会接受本人自批。",
      );
    }
    if (approvalPersonalSessionRequired) {
      return denied(
        request,
        decidedAt,
        "AUTHORIZATION_APPROVAL_PERSONAL_SESSION_REQUIRED",
        "审批执行必须由店长或老板使用自己的个人账号操作。",
        "请退出公共收银班次账号，再使用本人账号登录后执行。",
      );
    }
    if (workforcePersonalSessionRequired) {
      return denied(
        request,
        decidedAt,
        "AUTHORIZATION_WORKFORCE_PERSONAL_SESSION_REQUIRED",
        "换绑登录微信必须使用你自己的个人账号操作。",
        "请退出公共收银班次账号，再使用本人账号登录后重试。",
      );
    }
    if (orderCashRefundApplicantRoleConflict) {
      return denied(
        request,
        decidedAt,
        "AUTHORIZATION_APPROVAL_APPLICANT_ROLE_CONFLICT",
        "高权限账号不能同时作为这笔现金退款的收银申请人。",
        "请由当班收银员提交申请，再由另一位有权店长或老板审批。",
      );
    }
    if (serviceDutyInactive) {
      return denied(
        request,
        decidedAt,
        "AUTHORIZATION_SERVICE_DUTY_INACTIVE",
        "当前收银员没有正在承担本店服务职责。",
        "请先在工作中心承担服务职责，再接取或完成本店现场服务。",
      );
    }
    if (serviceRouteAckNotAllowed) {
      return denied(
        request,
        decidedAt,
        "AUTHORIZATION_SERVICE_ROUTE_ACK_NOT_ALLOWED",
        "这项服务没有分配给当前服务员角色。",
        "请处理分配给服务员的事项，或由本店店长调整服务路由。",
      );
    }
    if (serviceRequestTransferNotAllowed) {
      return denied(
        request,
        decidedAt,
        "AUTHORIZATION_SERVICE_REQUEST_TRANSFER_NOT_ALLOWED",
        "这项服务当前不能由该服务员转交。",
        "请由当前负责人处理，或联系本店店长按最新工作项状态转交。",
      );
    }
    return defaultDeny(request, decidedAt);
  }
  const best = [...applicable].sort(
    (left, right) => effectRank(right.rule.effect) - effectRank(left.rule.effect),
  )[0];
  if (!best) return defaultDeny(request, decidedAt);
  const approvalLevel = facts.get("REQUIRED_APPROVAL_LEVEL");
  if (
    best.rule.approvalLevelRequired &&
    approvalLevel !== "MANAGER_OR_OWNER" &&
    approvalLevel !== "MANAGER_THEN_OWNER"
  ) {
    return conditionMissing(request, decidedAt);
  }
  const template = best.rule.approvalLevelRequired
    ? approvalLevel === "MANAGER_THEN_OWNER"
      ? twoLevelTemplate
      : oneLevelTemplate
    : templateForEffect(best.rule.effect);
  const matchedRuleId = best.rule.approvalLevelRequired
    ? `${best.rule.ruleId}-${
        approvalLevel === "MANAGER_THEN_OWNER" ? "manager-then-owner" : "manager-or-owner"
      }`
    : best.rule.ruleId;
  return allowedDecision(request, decidedAt, template, matchedRuleId, {
    kind: "WORKFORCE_ROLE",
    principalType: "WORKFORCE",
    role: best.role,
    referenceId: null,
  });
}

function decideAccidentalVoid(
  request: AuthorizationRequest,
  roles: Set<WorkforceAuthorizationRole>,
  facts: Map<string, unknown>,
  decidedAt: string,
): AuthorizationDecision {
  if (!roles.has("CASHIER")) return defaultDeny(request, decidedAt);
  const required = [
    "NO_PRODUCT_FACT",
    "NO_COACH_FACT",
    "NO_PAYMENT_FACT",
    "BUSINESS_REASON_PRESENT",
  ];
  if (required.some((code) => typeof facts.get(code) !== "boolean")) {
    return conditionMissing(request, decidedAt);
  }
  if (
    facts.get("NO_PRODUCT_FACT") !== true ||
    facts.get("NO_COACH_FACT") !== true ||
    facts.get("NO_PAYMENT_FACT") !== true
  ) {
    const factType =
      facts.get("NO_PRODUCT_FACT") !== true
        ? "product"
        : facts.get("NO_COACH_FACT") !== true
          ? "coach"
          : "payment";
    return denied(
      request,
      decidedAt,
      "AUTHORIZATION_FACT_PRESERVATION_REQUIRED",
      "这张台单已经产生商品、助教或支付事实，不能再按误开台直接作废。",
      "请根据实际情况走退单、下钟、退款或冲正流程，原始记录会继续保留。",
      `cashier-table-void-accidental-preserve-${factType}`,
    );
  }
  if (facts.get("BUSINESS_REASON_PRESENT") !== true) return conditionMissing(request, decidedAt);
  return allowedDecision(
    request,
    decidedAt,
    directTemplate,
    "cashier-table-void-accidental-empty",
    {
      kind: "WORKFORCE_ROLE",
      principalType: "WORKFORCE",
      role: "CASHIER",
      referenceId: null,
    },
  );
}

function decideCustomerAuthorization(
  request: AuthorizationRequest,
  principal: CustomerAuthorizationPrincipal,
  facts: Map<string, unknown>,
  decidedAt: string,
): AuthorizationDecision {
  if (principal.sessionStatus !== "ACTIVE") return inactiveSession(request, decidedAt);
  if (
    request.scope.storeId !== principal.storeId ||
    request.scope.resourceId !== principal.id ||
    facts.get("TARGET_CUSTOMER_ID") !== principal.id ||
    request.projectionVersion !== null ||
    request.identityVersion !== principal.sessionVersion ||
    request.bindingVersion !== null ||
    request.projectionHash !== null ||
    request.authorizationFactHash !== null
  ) {
    return scopeMismatch(request, decidedAt);
  }
  if (!customerRules.has(`${request.resource}:${request.action}`)) {
    return defaultDeny(request, decidedAt);
  }
  return allowedDecision(
    request,
    decidedAt,
    directTemplate,
    `customer-${request.resource.toLowerCase()}-${request.action.toLowerCase()}`,
    { kind: "PRINCIPAL_SCOPE", principalType: "CUSTOMER", role: null, referenceId: principal.id },
  );
}

function decideKioskAuthorization(
  request: AuthorizationRequest,
  principal: KioskAuthorizationPrincipal,
  facts: Map<string, unknown>,
  decidedAt: string,
): AuthorizationDecision {
  if (
    principal.bindingStatus !== "ACTIVE" ||
    request.scope.storeId !== principal.storeId ||
    request.scope.resourceId !== principal.tableId ||
    facts.get("TARGET_TABLE_ID") !== principal.tableId ||
    request.bindingVersion !== principal.bindingVersion ||
    request.projectionVersion !== null ||
    request.identityVersion !== null ||
    request.projectionHash !== null ||
    request.authorizationFactHash !== null
  ) {
    return denied(
      request,
      decidedAt,
      "AUTHORIZATION_DEVICE_BINDING_INACTIVE",
      "这台桌边设备的绑定或桌台范围已经失效。",
      "请在门店设备管理页面重新核对并绑定本桌设备。",
    );
  }
  if (!kioskRules.has(`${request.resource}:${request.action}`)) {
    return defaultDeny(request, decidedAt);
  }
  return allowedDecision(
    request,
    decidedAt,
    directTemplate,
    `kiosk-${request.resource.toLowerCase()}-${request.action.toLowerCase()}`,
    { kind: "PRINCIPAL_SCOPE", principalType: "KIOSK", role: null, referenceId: principal.id },
  );
}

function decideSupportAuthorization(
  request: AuthorizationRequest,
  principal: SupportAuthorizationPrincipal,
  decidedAt: string,
): AuthorizationDecision {
  if (principal.sessionStatus !== "ACTIVE") return inactiveSession(request, decidedAt);
  if (
    request.projectionVersion !== null ||
    request.identityVersion !== null ||
    request.projectionHash !== null ||
    request.authorizationFactHash !== null ||
    !supportRules.has(`${request.resource}:${request.action}`)
  ) {
    return defaultDeny(request, decidedAt);
  }
  const nowMs = Date.parse(decidedAt);
  const grant = principal.grants.find(
    (candidate) =>
      candidate.status === "ACTIVE" &&
      candidate.version === request.bindingVersion &&
      candidate.storeId === request.scope.storeId &&
      (candidate.resourceId ?? null) === request.scope.resourceId &&
      candidate.resource === request.resource &&
      candidate.action === request.action &&
      Date.parse(candidate.validFrom) <= nowMs &&
      nowMs < Date.parse(candidate.validUntil),
  );
  if (!grant) return defaultDeny(request, decidedAt);
  return allowedDecision(request, decidedAt, directTemplate, `support-grant-${grant.grantId}`, {
    kind: "SUPPORT_GRANT",
    principalType: "SUPPORT",
    role: null,
    referenceId: grant.grantId,
  });
}

function decideServiceAuthorization(
  request: AuthorizationRequest,
  principal: ServiceAuthorizationPrincipal,
  decidedAt: string,
): AuthorizationDecision {
  const builtInScopes = serviceRules.get(principal.id);
  const exactScope = `${request.resource}:${request.action}`;
  if (
    principal.credentialStatus !== "ACTIVE" ||
    request.scope.storeId !== principal.storeId ||
    request.bindingVersion !== principal.credentialVersion ||
    request.projectionVersion !== null ||
    request.identityVersion !== null ||
    request.projectionHash !== null ||
    request.authorizationFactHash !== null ||
    !builtInScopes?.has(exactScope) ||
    !principal.scopes.some(
      (scope) => scope.resource === request.resource && scope.action === request.action,
    )
  ) {
    return defaultDeny(request, decidedAt);
  }
  return allowedDecision(
    request,
    decidedAt,
    directTemplate,
    `service-${principal.id}-${request.resource.toLowerCase()}-${request.action.toLowerCase()}`,
    { kind: "PRINCIPAL_SCOPE", principalType: "SERVICE", role: null, referenceId: principal.id },
  );
}

function affiliationIsCanonical(
  current: WorkforcePrincipalAffiliation,
  affiliations: WorkforcePrincipalAffiliation[],
): boolean {
  return affiliations.some(
    (candidate) =>
      candidate.storeId === current.storeId &&
      candidate.relationship === current.relationship &&
      candidate.employmentId === current.employmentId &&
      candidate.ownershipId === current.ownershipId &&
      candidate.coachId === current.coachId &&
      [...candidate.roles].sort().join("|") === [...current.roles].sort().join("|"),
  );
}

function inactiveSession(request: AuthorizationRequest, decidedAt: string): AuthorizationDecision {
  return denied(
    request,
    decidedAt,
    "AUTHORIZATION_SESSION_INACTIVE",
    "当前登录已经失效，不能继续执行这项操作。",
    "请重新登录；如果账号已停用，请联系老板或店长核对。",
  );
}

function versionMismatch(request: AuthorizationRequest, decidedAt: string): AuthorizationDecision {
  return denied(
    request,
    decidedAt,
    "AUTHORIZATION_VERSION_MISMATCH",
    "人员权限资料已经发生变化，旧决定不能继续使用。",
    "请刷新页面并重新确认当前身份和门店。",
  );
}

function scopeMismatch(request: AuthorizationRequest, decidedAt: string): AuthorizationDecision {
  return denied(
    request,
    decidedAt,
    "AUTHORIZATION_SCOPE_MISMATCH",
    "当前身份不能操作这个门店或对象。",
    "请返回当前身份允许的页面重新选择。",
  );
}

function conditionMissing(request: AuthorizationRequest, decidedAt: string): AuthorizationDecision {
  return denied(
    request,
    decidedAt,
    "AUTHORIZATION_CONDITION_MISSING",
    "系统还不能确认这项操作所需的完整业务条件，因此不会猜测放行。",
    "请刷新业务数据并补全页面要求的原因或状态后再试。",
  );
}

function conditionInvalid(request: AuthorizationRequest, decidedAt: string): AuthorizationDecision {
  return denied(
    request,
    decidedAt,
    "AUTHORIZATION_CONDITION_INVALID",
    "本次操作包含互相冲突的判断条件，系统不能安全确认权限。",
    "请刷新业务数据后重试；系统不会猜测采用其中一个条件。",
  );
}

function defaultDeny(request: AuthorizationRequest, decidedAt: string): AuthorizationDecision {
  return denied(
    request,
    decidedAt,
    "AUTHORIZATION_DEFAULT_DENY",
    "当前身份没有开放这项操作。",
    "请返回自己的工作台；如职责确需调整，请联系老板或店长。",
  );
}

function effectRank(effect: Exclude<AuthorizationEffect, "DENY">): number {
  if (effect === "DIRECT") return 3;
  if (effect === "MANAGER_OR_OWNER_APPROVAL") return 2;
  return 1;
}

function templateForEffect(effect: Exclude<AuthorizationEffect, "DENY">): DecisionTemplate {
  if (effect === "DIRECT") return directTemplate;
  if (effect === "MANAGER_OR_OWNER_APPROVAL") return oneLevelTemplate;
  return twoLevelTemplate;
}

function snapshotRule(
  ruleId: string,
  principalTypes: AuthorizationPrincipalType[],
  resource: string,
  action: string,
  priority: number,
  conditions: AuthorizationPolicyCondition[],
  effect: AuthorizationEffect,
  reasonCode: string,
  message: string,
  nextStep: string,
): AuthorizationPolicyRule {
  const common = {
    ruleId,
    principalTypes,
    resource,
    action,
    priority,
    conditions,
    message,
    nextStep,
  };
  if (effect === "DIRECT") {
    if (reasonCode !== "AUTHORIZATION_DIRECT") throw new Error("invalid direct policy reason");
    return { ...common, effect, reasonCode: "AUTHORIZATION_DIRECT" };
  }
  if (effect === "MANAGER_OR_OWNER_APPROVAL") {
    if (reasonCode !== "AUTHORIZATION_MANAGER_OR_OWNER_APPROVAL_REQUIRED") {
      throw new Error("invalid manager-or-owner policy reason");
    }
    return { ...common, effect, reasonCode: "AUTHORIZATION_MANAGER_OR_OWNER_APPROVAL_REQUIRED" };
  }
  if (effect === "MANAGER_THEN_OWNER_APPROVAL") {
    if (reasonCode !== "AUTHORIZATION_MANAGER_THEN_OWNER_APPROVAL_REQUIRED") {
      throw new Error("invalid manager-then-owner policy reason");
    }
    return {
      ...common,
      effect,
      reasonCode: "AUTHORIZATION_MANAGER_THEN_OWNER_APPROVAL_REQUIRED",
    };
  }
  if (
    reasonCode === "AUTHORIZATION_DIRECT" ||
    reasonCode === "AUTHORIZATION_MANAGER_OR_OWNER_APPROVAL_REQUIRED" ||
    reasonCode === "AUTHORIZATION_MANAGER_THEN_OWNER_APPROVAL_REQUIRED"
  ) {
    throw new Error("invalid deny policy reason");
  }
  return { ...common, effect: "DENY", reasonCode };
}

function completePolicyRules(
  workforcePolicyRules: readonly WorkforceRule[] = workforceRules,
): AuthorizationPolicyRule[] {
  const workforce = workforcePolicyRules.flatMap((candidate) => {
    if (candidate.approvalLevelRequired) {
      return [
        snapshotRule(
          `${candidate.ruleId}-manager-or-owner`,
          ["WORKFORCE"],
          candidate.resource,
          candidate.action,
          500,
          [
            {
              source: "PRINCIPAL",
              code: "WORKFORCE_ROLE",
              operator: "INCLUDES_ANY",
              value: candidate.roles.join("|"),
            },
            {
              source: "TRUSTED_FACT",
              code: "REQUIRED_APPROVAL_LEVEL",
              operator: "EQUALS",
              value: "MANAGER_OR_OWNER",
            },
          ],
          "MANAGER_OR_OWNER_APPROVAL",
          oneLevelTemplate.reasonCode,
          oneLevelTemplate.message,
          oneLevelTemplate.nextStep,
        ),
        snapshotRule(
          `${candidate.ruleId}-manager-then-owner`,
          ["WORKFORCE"],
          candidate.resource,
          candidate.action,
          500,
          [
            {
              source: "PRINCIPAL",
              code: "WORKFORCE_ROLE",
              operator: "INCLUDES_ANY",
              value: candidate.roles.join("|"),
            },
            {
              source: "TRUSTED_FACT",
              code: "REQUIRED_APPROVAL_LEVEL",
              operator: "EQUALS",
              value: "MANAGER_THEN_OWNER",
            },
          ],
          "MANAGER_THEN_OWNER_APPROVAL",
          twoLevelTemplate.reasonCode,
          twoLevelTemplate.message,
          twoLevelTemplate.nextStep,
        ),
      ];
    }
    const template = templateForEffect(candidate.effect);
    return [
      snapshotRule(
        candidate.ruleId,
        ["WORKFORCE"],
        candidate.resource,
        candidate.action,
        500,
        [
          {
            source: "PRINCIPAL",
            code: "WORKFORCE_ROLE",
            operator: "INCLUDES_ANY",
            value: candidate.roles.join("|"),
          },
          ...(candidate.selfOnly
            ? [
                {
                  source: "TRUSTED_FACT" as const,
                  code: "TARGET_COACH_ID",
                  operator: "MATCHES_PRINCIPAL" as const,
                  value: "CURRENT_COACH_ID",
                },
              ]
            : []),
          ...(candidate.approvalApplicantRelation
            ? [
                {
                  source: "TRUSTED_FACT" as const,
                  code: "APPROVAL_APPLICANT_IS_SELF",
                  operator: "EQUALS" as const,
                  value: candidate.approvalApplicantRelation === "SELF",
                },
              ]
            : []),
          ...(candidate.orderCashRefundApplicantOnly
            ? [
                {
                  source: "PRINCIPAL" as const,
                  code: "WORKFORCE_ROLE_BOUNDARY",
                  operator: "EQUALS" as const,
                  value: "CASHIER_WITHOUT_OWNER_OR_MANAGER",
                },
              ]
            : []),
          ...(candidate.personalSessionRequired
            ? [
                {
                  source: "TRUSTED_FACT" as const,
                  code: "APPROVAL_EXECUTOR_SESSION_IS_PERSONAL",
                  operator: "EQUALS" as const,
                  value: true,
                },
              ]
            : []),
          ...(candidate.workforcePersonalSessionRequired
            ? [
                {
                  source: "TRUSTED_FACT" as const,
                  code: "WORKFORCE_SESSION_IS_PERSONAL",
                  operator: "EQUALS" as const,
                  value: true,
                },
              ]
            : []),
          ...(candidate.serviceDutyActiveRequired
            ? [
                {
                  source: "TRUSTED_FACT" as const,
                  code: "SERVICE_DUTY_ACTIVE",
                  operator: "EQUALS" as const,
                  value: true,
                },
              ]
            : []),
          ...(candidate.serviceRouteAckAllowedRequired
            ? [
                {
                  source: "TRUSTED_FACT" as const,
                  code: "SERVICE_ROUTE_ACK_ALLOWED",
                  operator: "EQUALS" as const,
                  value: true,
                },
              ]
            : []),
          ...(candidate.serviceRequestTransferAllowedRequired
            ? [
                {
                  source: "TRUSTED_FACT" as const,
                  code: "SERVICE_REQUEST_TRANSFER_ALLOWED",
                  operator: "EQUALS" as const,
                  value: true,
                },
              ]
            : []),
        ],
        candidate.effect,
        template.reasonCode,
        template.message,
        template.nextStep,
      ),
    ];
  });
  const hard = [...hardConstraintPairs].map(([pair, ruleId]) => {
    const [resource, action] = pair.split(":") as [string, string];
    return snapshotRule(
      ruleId,
      ["WORKFORCE", "CUSTOMER", "KIOSK", "SUPPORT", "SERVICE"],
      resource,
      action,
      1_000,
      [],
      "DENY",
      "AUTHORIZATION_HARD_CONSTRAINT",
      "这项操作会突破系统必须遵守的安全规则。",
      "请使用系统提供的安全更正流程。",
    );
  });
  const scoped = [
    ...[...customerRules].map((pair) =>
      scopedSnapshotRule("customer", "CUSTOMER", pair, "TARGET_CUSTOMER_ID"),
    ),
    ...[...kioskRules].map((pair) => scopedSnapshotRule("kiosk", "KIOSK", pair, "TARGET_TABLE_ID")),
    ...[...supportRules].map((pair) =>
      scopedSnapshotRule("support", "SUPPORT", pair, "ACTIVE_VERSIONED_GRANT"),
    ),
    ...[...serviceRules].flatMap(([serviceId, pairs]) =>
      [...pairs].map((pair) =>
        scopedSnapshotRule(`service-${serviceId}`, "SERVICE", pair, "ACTIVE_CREDENTIAL_SCOPE"),
      ),
    ),
  ];
  return [
    ...hard,
    ...workforce,
    snapshotRule(
      "cashier-table-void-accidental-empty",
      ["WORKFORCE"],
      "TABLE_SESSION",
      "VOID_ACCIDENTAL",
      700,
      [
        { source: "PRINCIPAL", code: "WORKFORCE_ROLE", operator: "INCLUDES_ANY", value: "CASHIER" },
        { source: "TRUSTED_FACT", code: "NO_PRODUCT_FACT", operator: "EQUALS", value: true },
        { source: "TRUSTED_FACT", code: "NO_COACH_FACT", operator: "EQUALS", value: true },
        { source: "TRUSTED_FACT", code: "NO_PAYMENT_FACT", operator: "EQUALS", value: true },
        {
          source: "TRUSTED_FACT",
          code: "BUSINESS_REASON_PRESENT",
          operator: "EQUALS",
          value: true,
        },
      ],
      "DIRECT",
      directTemplate.reasonCode,
      directTemplate.message,
      directTemplate.nextStep,
    ),
    ...(["PRODUCT", "COACH", "PAYMENT"] as const).map((factType) =>
      snapshotRule(
        `cashier-table-void-accidental-preserve-${factType.toLowerCase()}`,
        ["WORKFORCE"],
        "TABLE_SESSION",
        "VOID_ACCIDENTAL",
        800,
        [
          {
            source: "PRINCIPAL",
            code: "WORKFORCE_ROLE",
            operator: "INCLUDES_ANY",
            value: "CASHIER",
          },
          {
            source: "TRUSTED_FACT",
            code: `NO_${factType}_FACT`,
            operator: "EQUALS",
            value: false,
          },
        ],
        "DENY",
        "AUTHORIZATION_FACT_PRESERVATION_REQUIRED",
        "已有业务事实的台单不能直接作废。",
        "请使用退单、退款或冲正流程。",
      ),
    ),
    ...scoped,
    snapshotRule(
      "default-deny",
      ["WORKFORCE", "CUSTOMER", "KIOSK", "SUPPORT", "SERVICE"],
      "UNDECLARED_COMBINATION",
      "DENY",
      0,
      [{ source: "POLICY", code: "DEFAULT_RULE", operator: "EQUALS", value: true }],
      "DENY",
      "AUTHORIZATION_DEFAULT_DENY",
      "未明确开放的操作一律不允许。",
      "请返回当前身份允许的工作台。",
    ),
  ];
}

function scopedSnapshotRule(
  prefix: string,
  principalType: Exclude<AuthorizationPrincipalType, "WORKFORCE">,
  pair: string,
  conditionCode: string,
): AuthorizationPolicyRule {
  const [resource, action] = pair.split(":") as [string, string];
  const condition: AuthorizationPolicyCondition =
    principalType === "CUSTOMER" || principalType === "KIOSK"
      ? {
          source: "TRUSTED_FACT",
          code: conditionCode,
          operator: "MATCHES_PRINCIPAL",
          value: principalType === "CUSTOMER" ? "CUSTOMER_ID" : "TABLE_ID",
        }
      : {
          source: "PRINCIPAL",
          code: conditionCode,
          operator: "ACTIVE_AND_VERSIONED",
          value: principalType === "SUPPORT" ? "SUPPORT_GRANT" : "CREDENTIAL_SCOPE",
        };
  return snapshotRule(
    `${prefix}-${resource.toLowerCase()}-${action.toLowerCase()}`,
    [principalType],
    resource,
    action,
    500,
    [condition],
    "DIRECT",
    directTemplate.reasonCode,
    directTemplate.message,
    directTemplate.nextStep,
  );
}

export function authorizationPolicySnapshotV1(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01",
    policyContentSha256: AUTHORIZATION_POLICY_V1_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V1_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV2(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v2",
    policyContentSha256: AUTHORIZATION_POLICY_V2_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V2_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV2),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV3(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v3",
    policyContentSha256: AUTHORIZATION_POLICY_V3_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V3_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV3),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV4(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v4",
    policyContentSha256: AUTHORIZATION_POLICY_V4_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V4_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV4),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV5(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v5",
    policyContentSha256: AUTHORIZATION_POLICY_V5_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V5_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV5),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV6(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v6",
    policyContentSha256: AUTHORIZATION_POLICY_V6_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V6_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV6),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV7(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v7",
    policyContentSha256: AUTHORIZATION_POLICY_V7_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V7_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV7),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV8(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v8",
    policyContentSha256: AUTHORIZATION_POLICY_V8_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V8_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV8),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV9(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v9",
    policyContentSha256: AUTHORIZATION_POLICY_V9_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V9_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV9),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV10(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v10",
    policyContentSha256: AUTHORIZATION_POLICY_V10_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V10_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV10),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV11(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v11",
    policyContentSha256: AUTHORIZATION_POLICY_V11_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V11_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV11),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV12(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v12",
    policyContentSha256: AUTHORIZATION_POLICY_V12_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V12_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV12),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV13(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v13",
    policyContentSha256: AUTHORIZATION_POLICY_V13_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V13_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV13),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV14(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v14",
    policyContentSha256: AUTHORIZATION_POLICY_V14_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V14_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV14),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV15(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v15",
    policyContentSha256: AUTHORIZATION_POLICY_V15_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V15_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV15),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV16(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v16",
    policyContentSha256: AUTHORIZATION_POLICY_V16_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V16_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV16),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV17(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v17",
    policyContentSha256: AUTHORIZATION_POLICY_V17_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V17_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV17),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV18(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-01-v18",
    policyContentSha256: AUTHORIZATION_POLICY_V18_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V18_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV18),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV19(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-02-v19",
    policyContentSha256: AUTHORIZATION_POLICY_V19_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V19_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV19),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV20(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-03-03-v20",
    policyContentSha256: AUTHORIZATION_POLICY_V20_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V20_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV20),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV21(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-05-03-v21",
    policyContentSha256: AUTHORIZATION_POLICY_V21_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V21_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV21),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV22(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-base-05-03-v22",
    policyContentSha256: AUTHORIZATION_POLICY_V22_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V22_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV22),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV23(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-bug-cur-01-v23",
    policyContentSha256: AUTHORIZATION_POLICY_V23_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V23_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV23),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV24(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-core-08-02-v24",
    policyContentSha256: AUTHORIZATION_POLICY_V24_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V24_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV24),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV25(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-core-08-02-v25",
    policyContentSha256: AUTHORIZATION_POLICY_V25_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V25_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV25),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV26(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-core-08-02-v26",
    policyContentSha256: AUTHORIZATION_POLICY_V26_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V26_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV26),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV27(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-core-08-02-v27",
    policyContentSha256: AUTHORIZATION_POLICY_V27_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V27_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV27),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV28(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-core-08-02-v28",
    policyContentSha256: AUTHORIZATION_POLICY_V28_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V28_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV28),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV29(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-core-08-02-v29",
    policyContentSha256: AUTHORIZATION_POLICY_V29_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V29_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV29),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV30(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-core-06-03-v30",
    policyContentSha256: AUTHORIZATION_POLICY_V30_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V30_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV30),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV31(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-ops-04-v31",
    policyContentSha256: AUTHORIZATION_POLICY_V31_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V31_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV31),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV32(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-coach-service-correction-v32",
    policyContentSha256: AUTHORIZATION_POLICY_V32_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V32_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV32),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV33(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-store-operating-day-v33",
    policyContentSha256: AUTHORIZATION_POLICY_V33_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V33_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV33),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV34(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-store-closing-v34",
    policyContentSha256: AUTHORIZATION_POLICY_V34_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V34_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV34),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV35(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-workforce-attendance-v35",
    policyContentSha256: AUTHORIZATION_POLICY_V35_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V35_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV35),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV36(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-workforce-account-wechat-rebind-v36",
    policyContentSha256: AUTHORIZATION_POLICY_V36_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V36_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV36),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV37(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-workforce-account-phone-change-v37",
    policyContentSha256: AUTHORIZATION_POLICY_V37_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V37_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV37),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV38(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-store-device-manual-resolution-v38",
    policyContentSha256: AUTHORIZATION_POLICY_V38_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V38_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV38),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV39(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-group-buy-redemption-v39",
    policyContentSha256: AUTHORIZATION_POLICY_V39_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V39_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV39),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV40(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-coach-operating-roles-v40",
    policyContentSha256: AUTHORIZATION_POLICY_V40_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V40_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV40),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV41(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-member-recharge-v41",
    policyContentSha256: AUTHORIZATION_POLICY_V41_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V41_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV41),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV42(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-group-buy-manual-fulfillment-v42",
    policyContentSha256: AUTHORIZATION_POLICY_V42_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V42_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV42),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV43(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-customer-storage-v43",
    policyContentSha256: AUTHORIZATION_POLICY_V43_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V43_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV43),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV44(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-customer-rental-v44",
    policyContentSha256: AUTHORIZATION_POLICY_V44_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V44_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV44),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV45(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-workforce-payroll-v45",
    policyContentSha256: AUTHORIZATION_POLICY_V45_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V45_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV45),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV46(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-support-access-v46",
    policyContentSha256: AUTHORIZATION_POLICY_V46_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V46_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV46),
    generatedAt,
  };
}

export function authorizationPolicySnapshotV47(generatedAt: string): AuthorizationPolicySnapshot {
  return {
    policyId: "policy-manual-review-resolution-v47",
    policyContentSha256: AUTHORIZATION_POLICY_V47_CONTENT_SHA256,
    scope: { tenantId: "tenant-policy-template", storeId: null, resourceId: null },
    policyVersion: AUTHORIZATION_POLICY_V47_VERSION,
    projectionVersion: null,
    identityVersion: null,
    bindingVersion: null,
    projectionHash: null,
    authorizationFactHash: null,
    conditionSource: "SERVER_TRUSTED_ONLY",
    replayMode: "VERSIONED_DOMAIN_RUNTIME",
    defaultEffect: "DENY",
    evaluationOrder: [
      "TRUST_BOUNDARY",
      "HARD_CONSTRAINT",
      "IDENTITY_AND_SCOPE",
      "EXPLICIT_RULE",
      "DEFAULT_DENY",
    ],
    rules: completePolicyRules(workforceRulesV47),
    generatedAt,
  };
}

export function authorizationPolicySnapshot(generatedAt: string): AuthorizationPolicySnapshot {
  return authorizationPolicySnapshotV47(generatedAt);
}

export interface AuthorizationPolicySnapshotValidation {
  valid: boolean;
  issues: Array<
    | "SCHEMA_INVALID"
    | "DUPLICATE_RULE_ID"
    | "CONTENT_HASH_MISMATCH"
    | "POLICY_VERSION_UNSUPPORTED"
    | "POLICY_CONTENT_MISMATCH"
  >;
}

function snapshotContent(snapshot: AuthorizationPolicySnapshot): object {
  const {
    policyContentSha256: _policyContentSha256,
    generatedAt: _generatedAt,
    ...content
  } = snapshot;
  return content;
}

async function sha256Hex(value: string): Promise<string> {
  const digest = await globalThis.crypto.subtle.digest("SHA-256", new TextEncoder().encode(value));
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, "0")).join("");
}

export async function validateAuthorizationPolicySnapshot(
  value: unknown,
): Promise<AuthorizationPolicySnapshotValidation> {
  if (!isAuthorizationPolicySnapshot(value)) return { valid: false, issues: ["SCHEMA_INVALID"] };
  const issues: AuthorizationPolicySnapshotValidation["issues"] = [];
  const ruleIds = value.rules.map((rule) => rule.ruleId);
  if (new Set(ruleIds).size !== ruleIds.length) issues.push("DUPLICATE_RULE_ID");

  const content = snapshotContent(value);
  const computedHash = await sha256Hex(JSON.stringify(content));
  if (computedHash !== value.policyContentSha256) issues.push("CONTENT_HASH_MISMATCH");

  const expected =
    value.policyVersion === AUTHORIZATION_POLICY_V1_VERSION
      ? authorizationPolicySnapshotV1(value.generatedAt)
      : value.policyVersion === AUTHORIZATION_POLICY_V2_VERSION
        ? authorizationPolicySnapshotV2(value.generatedAt)
        : value.policyVersion === AUTHORIZATION_POLICY_V3_VERSION
          ? authorizationPolicySnapshotV3(value.generatedAt)
          : value.policyVersion === AUTHORIZATION_POLICY_V4_VERSION
            ? authorizationPolicySnapshotV4(value.generatedAt)
            : value.policyVersion === AUTHORIZATION_POLICY_V5_VERSION
              ? authorizationPolicySnapshotV5(value.generatedAt)
              : value.policyVersion === AUTHORIZATION_POLICY_V6_VERSION
                ? authorizationPolicySnapshotV6(value.generatedAt)
                : value.policyVersion === AUTHORIZATION_POLICY_V7_VERSION
                  ? authorizationPolicySnapshotV7(value.generatedAt)
                  : value.policyVersion === AUTHORIZATION_POLICY_V8_VERSION
                    ? authorizationPolicySnapshotV8(value.generatedAt)
                    : value.policyVersion === AUTHORIZATION_POLICY_V9_VERSION
                      ? authorizationPolicySnapshotV9(value.generatedAt)
                      : value.policyVersion === AUTHORIZATION_POLICY_V10_VERSION
                        ? authorizationPolicySnapshotV10(value.generatedAt)
                        : value.policyVersion === AUTHORIZATION_POLICY_V11_VERSION
                          ? authorizationPolicySnapshotV11(value.generatedAt)
                          : value.policyVersion === AUTHORIZATION_POLICY_V12_VERSION
                            ? authorizationPolicySnapshotV12(value.generatedAt)
                            : value.policyVersion === AUTHORIZATION_POLICY_V13_VERSION
                              ? authorizationPolicySnapshotV13(value.generatedAt)
                              : value.policyVersion === AUTHORIZATION_POLICY_V14_VERSION
                                ? authorizationPolicySnapshotV14(value.generatedAt)
                                : value.policyVersion === AUTHORIZATION_POLICY_V15_VERSION
                                  ? authorizationPolicySnapshotV15(value.generatedAt)
                                  : value.policyVersion === AUTHORIZATION_POLICY_V16_VERSION
                                    ? authorizationPolicySnapshotV16(value.generatedAt)
                                    : value.policyVersion === AUTHORIZATION_POLICY_V17_VERSION
                                      ? authorizationPolicySnapshotV17(value.generatedAt)
                                      : value.policyVersion === AUTHORIZATION_POLICY_V18_VERSION
                                        ? authorizationPolicySnapshotV18(value.generatedAt)
                                        : value.policyVersion === AUTHORIZATION_POLICY_V19_VERSION
                                          ? authorizationPolicySnapshotV19(value.generatedAt)
                                          : value.policyVersion === AUTHORIZATION_POLICY_V20_VERSION
                                            ? authorizationPolicySnapshotV20(value.generatedAt)
                                            : value.policyVersion ===
                                                AUTHORIZATION_POLICY_V21_VERSION
                                              ? authorizationPolicySnapshotV21(value.generatedAt)
                                              : value.policyVersion ===
                                                  AUTHORIZATION_POLICY_V22_VERSION
                                                ? authorizationPolicySnapshotV22(value.generatedAt)
                                                : value.policyVersion ===
                                                    AUTHORIZATION_POLICY_V23_VERSION
                                                  ? authorizationPolicySnapshotV23(
                                                      value.generatedAt,
                                                    )
                                                  : value.policyVersion ===
                                                      AUTHORIZATION_POLICY_V24_VERSION
                                                    ? authorizationPolicySnapshotV24(
                                                        value.generatedAt,
                                                      )
                                                    : value.policyVersion ===
                                                        AUTHORIZATION_POLICY_V25_VERSION
                                                      ? authorizationPolicySnapshotV25(
                                                          value.generatedAt,
                                                        )
                                                      : value.policyVersion ===
                                                          AUTHORIZATION_POLICY_V26_VERSION
                                                        ? authorizationPolicySnapshotV26(
                                                            value.generatedAt,
                                                          )
                                                        : value.policyVersion ===
                                                            AUTHORIZATION_POLICY_V27_VERSION
                                                          ? authorizationPolicySnapshotV27(
                                                              value.generatedAt,
                                                            )
                                                          : value.policyVersion ===
                                                              AUTHORIZATION_POLICY_V28_VERSION
                                                            ? authorizationPolicySnapshotV28(
                                                                value.generatedAt,
                                                              )
                                                            : value.policyVersion ===
                                                                AUTHORIZATION_POLICY_V29_VERSION
                                                              ? authorizationPolicySnapshotV29(
                                                                  value.generatedAt,
                                                                )
                                                              : value.policyVersion ===
                                                                  AUTHORIZATION_POLICY_V30_VERSION
                                                                ? authorizationPolicySnapshotV30(
                                                                    value.generatedAt,
                                                                  )
                                                                : value.policyVersion ===
                                                                    AUTHORIZATION_POLICY_V31_VERSION
                                                                  ? authorizationPolicySnapshotV31(
                                                                      value.generatedAt,
                                                                    )
                                                                  : value.policyVersion ===
                                                                      AUTHORIZATION_POLICY_V32_VERSION
                                                                    ? authorizationPolicySnapshotV32(
                                                                        value.generatedAt,
                                                                      )
                                                                    : value.policyVersion ===
                                                                        AUTHORIZATION_POLICY_V33_VERSION
                                                                      ? authorizationPolicySnapshotV33(
                                                                          value.generatedAt,
                                                                        )
                                                                      : value.policyVersion ===
                                                                          AUTHORIZATION_POLICY_V34_VERSION
                                                                        ? authorizationPolicySnapshotV34(
                                                                            value.generatedAt,
                                                                          )
                                                                        : value.policyVersion ===
                                                                            AUTHORIZATION_POLICY_V35_VERSION
                                                                          ? authorizationPolicySnapshotV35(
                                                                              value.generatedAt,
                                                                            )
                                                                          : value.policyVersion ===
                                                                              AUTHORIZATION_POLICY_V36_VERSION
                                                                            ? authorizationPolicySnapshotV36(
                                                                                value.generatedAt,
                                                                              )
                                                                            : value.policyVersion ===
                                                                                AUTHORIZATION_POLICY_V37_VERSION
                                                                              ? authorizationPolicySnapshotV37(
                                                                                  value.generatedAt,
                                                                                )
                                                                              : value.policyVersion ===
                                                                                  AUTHORIZATION_POLICY_V38_VERSION
                                                                                ? authorizationPolicySnapshotV38(
                                                                                    value.generatedAt,
                                                                                  )
                                                                                : value.policyVersion ===
                                                                                    AUTHORIZATION_POLICY_V39_VERSION
                                                                                  ? authorizationPolicySnapshotV39(
                                                                                      value.generatedAt,
                                                                                    )
                                                                                  : value.policyVersion ===
                                                                                      AUTHORIZATION_POLICY_V40_VERSION
                                                                                    ? authorizationPolicySnapshotV40(
                                                                                        value.generatedAt,
                                                                                      )
                                                                                    : value.policyVersion ===
                                                                                        AUTHORIZATION_POLICY_V41_VERSION
                                                                                      ? authorizationPolicySnapshotV41(
                                                                                          value.generatedAt,
                                                                                        )
                                                                                      : value.policyVersion ===
                                                                                          AUTHORIZATION_POLICY_V42_VERSION
                                                                                        ? authorizationPolicySnapshotV42(
                                                                                            value.generatedAt,
                                                                                          )
                                                                                        : value.policyVersion ===
                                                                                            AUTHORIZATION_POLICY_V43_VERSION
                                                                                          ? authorizationPolicySnapshotV43(
                                                                                              value.generatedAt,
                                                                                            )
                                                                                          : value.policyVersion ===
                                                                                              AUTHORIZATION_POLICY_V44_VERSION
                                                                                            ? authorizationPolicySnapshotV44(
                                                                                                value.generatedAt,
                                                                                              )
                                                                                            : value.policyVersion ===
                                                                                                AUTHORIZATION_POLICY_V45_VERSION
                                                                                              ? authorizationPolicySnapshotV45(
                                                                                                  value.generatedAt,
                                                                                                )
                                                                                              : value.policyVersion ===
                                                                                                  AUTHORIZATION_POLICY_V46_VERSION
                                                                                                ? authorizationPolicySnapshotV46(
                                                                                                    value.generatedAt,
                                                                                                  )
                                                                                                : value.policyVersion ===
                                                                                                    AUTHORIZATION_POLICY_V47_VERSION
                                                                                                  ? authorizationPolicySnapshotV47(
                                                                                                      value.generatedAt,
                                                                                                    )
                                                                                                  : null;
  if (
    !expected ||
    value.policyId !== expected.policyId ||
    value.policyContentSha256 !== expected.policyContentSha256
  ) {
    issues.push("POLICY_VERSION_UNSUPPORTED");
  }
  if (!expected || JSON.stringify(content) !== JSON.stringify(snapshotContent(expected))) {
    issues.push("POLICY_CONTENT_MISMATCH");
  }
  return { valid: issues.length === 0, issues: [...new Set(issues)] };
}

/**
 * Official replay for the built-in, hash-bound policy. Snapshot predicates are audit material;
 * their source/operator semantics are executed only by this versioned domain runtime.
 */
export async function replayAuthorizationPolicySnapshot(
  snapshot: unknown,
  input: AuthorizationEvaluationInput,
): Promise<AuthorizationDecision> {
  const validation = await validateAuthorizationPolicySnapshot(snapshot);
  if (!validation.valid) {
    throw new Error(`authorization policy snapshot rejected: ${validation.issues.join(",")}`);
  }
  const acceptedSnapshot = snapshot as AuthorizationPolicySnapshot;
  switch (acceptedSnapshot.policyVersion) {
    case AUTHORIZATION_POLICY_V1_VERSION:
      return decideAuthorizationV1(input);
    case AUTHORIZATION_POLICY_V2_VERSION:
      return decideAuthorizationV2(input);
    case AUTHORIZATION_POLICY_V3_VERSION:
      return decideAuthorizationV3(input);
    case AUTHORIZATION_POLICY_V4_VERSION:
      return decideAuthorizationV4(input);
    case AUTHORIZATION_POLICY_V5_VERSION:
      return decideAuthorizationV5(input);
    case AUTHORIZATION_POLICY_V6_VERSION:
      return decideAuthorizationV6(input);
    case AUTHORIZATION_POLICY_V7_VERSION:
      return decideAuthorizationV7(input);
    case AUTHORIZATION_POLICY_V8_VERSION:
      return decideAuthorizationV8(input);
    case AUTHORIZATION_POLICY_V9_VERSION:
      return decideAuthorizationV9(input);
    case AUTHORIZATION_POLICY_V10_VERSION:
      return decideAuthorizationV10(input);
    case AUTHORIZATION_POLICY_V11_VERSION:
      return decideAuthorizationV11(input);
    case AUTHORIZATION_POLICY_V12_VERSION:
      return decideAuthorizationV12(input);
    case AUTHORIZATION_POLICY_V13_VERSION:
      return decideAuthorizationV13(input);
    case AUTHORIZATION_POLICY_V14_VERSION:
      return decideAuthorizationV14(input);
    case AUTHORIZATION_POLICY_V15_VERSION:
      return decideAuthorizationV15(input);
    case AUTHORIZATION_POLICY_V16_VERSION:
      return decideAuthorizationV16(input);
    case AUTHORIZATION_POLICY_V17_VERSION:
      return decideAuthorizationV17(input);
    case AUTHORIZATION_POLICY_V18_VERSION:
      return decideAuthorizationV18(input);
    case AUTHORIZATION_POLICY_V19_VERSION:
      return decideAuthorizationV19(input);
    case AUTHORIZATION_POLICY_V20_VERSION:
      return decideAuthorizationV20(input);
    case AUTHORIZATION_POLICY_V21_VERSION:
      return decideAuthorizationV21(input);
    case AUTHORIZATION_POLICY_V22_VERSION:
      return decideAuthorizationV22(input);
    case AUTHORIZATION_POLICY_V23_VERSION:
      return decideAuthorizationV23(input);
    case AUTHORIZATION_POLICY_V24_VERSION:
      return decideAuthorizationV24(input);
    case AUTHORIZATION_POLICY_V25_VERSION:
      return decideAuthorizationV25(input);
    case AUTHORIZATION_POLICY_V26_VERSION:
      return decideAuthorizationV26(input);
    case AUTHORIZATION_POLICY_V27_VERSION:
      return decideAuthorizationV27(input);
    case AUTHORIZATION_POLICY_V28_VERSION:
      return decideAuthorizationV28(input);
    case AUTHORIZATION_POLICY_V29_VERSION:
      return decideAuthorizationV29(input);
    case AUTHORIZATION_POLICY_V30_VERSION:
      return decideAuthorizationV30(input);
    case AUTHORIZATION_POLICY_V31_VERSION:
      return decideAuthorizationV31(input);
    case AUTHORIZATION_POLICY_V32_VERSION:
      return decideAuthorizationV32(input);
    case AUTHORIZATION_POLICY_V33_VERSION:
      return decideAuthorizationV33(input);
    case AUTHORIZATION_POLICY_V34_VERSION:
      return decideAuthorizationV34(input);
    case AUTHORIZATION_POLICY_V35_VERSION:
      return decideAuthorizationV35(input);
    case AUTHORIZATION_POLICY_V36_VERSION:
      return decideAuthorizationV36(input);
    case AUTHORIZATION_POLICY_V37_VERSION:
      return decideAuthorizationV37(input);
    case AUTHORIZATION_POLICY_V38_VERSION:
      return decideAuthorizationV38(input);
    case AUTHORIZATION_POLICY_V39_VERSION:
      return decideAuthorizationV39(input);
    case AUTHORIZATION_POLICY_V40_VERSION:
      return decideAuthorizationV40(input);
    case AUTHORIZATION_POLICY_V41_VERSION:
      return decideAuthorizationV41(input);
    case AUTHORIZATION_POLICY_V42_VERSION:
      return decideAuthorizationV42(input);
    case AUTHORIZATION_POLICY_V43_VERSION:
      return decideAuthorizationV43(input);
    case AUTHORIZATION_POLICY_V44_VERSION:
      return decideAuthorizationV44(input);
    case AUTHORIZATION_POLICY_V45_VERSION:
      return decideAuthorizationV45(input);
    case AUTHORIZATION_POLICY_V46_VERSION:
      return decideAuthorizationV46(input);
    case AUTHORIZATION_POLICY_V47_VERSION:
      return decideAuthorizationV47(input);
    default:
      throw new Error(
        `authorization policy runtime missing for version ${acceptedSnapshot.policyVersion}`,
      );
  }
}
